const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        'Sélectionnez la catégorie principale du bâtiment, par exemple bureau, école ou entrepôt. Ce champ sert à choisir les valeurs standard et les profils corrects dans le calcul.',
      yearOfConstruction:
        "Indiquez l'année de construction du bâtiment, ou l'année de la dernière rénovation majeure si elle est plus représentative. Utilisé entre autres pour évaluer le niveau technique probable.",
      numberOfFloors:
        "Indiquez le nombre total d'étages hors sol du bâtiment. Ce champ sert de base pour la géométrie, le volume et la répartition en zones.",
    },
    thermalZones: {
      zoneCategory:
        "Une zone thermique est une partie du bâtiment traitée comme une seule unité dans le calcul, généralement avec un usage et un climat intérieur similaires. Donnez à la zone un nom clair et sélectionnez une catégorie de zone. La catégorie définit les profils standard de temps d'utilisation, de charges internes et d'hypothèses techniques.",
      buildingSubcategory:
        'Sélectionnez une sous-catégorie si vous souhaitez une classification plus précise de la zone. Laissez le champ vide si la catégorie de zone habituelle suffit.',
      zoneClimate:
        'Indique si la zone est chauffée, partiellement chauffée ou non chauffée. Le statut climatique détermine comment la zone entre dans le besoin de chauffage et de refroidissement et constitue une condition fondamentale pour le calcul énergétique.',
      bra: "BRA est la surface utile de la zone, c'est-à-dire la surface de plancher à l'intérieur des murs extérieurs comptée comme surface chauffée. Indiquez la BRA en m². La surface est l'une des données les plus importantes et influence directement presque tous les calculs.",
      floors:
        "Indiquez sur combien d'étages la zone s'étend si elle ne se limite pas à un seul niveau. Si la zone se trouve sur un seul niveau, le champ peut souvent rester vide.",
      floorHeight:
        "Indiquez la hauteur d'étage moyenne en mètres pour la zone. Utilisée avec la surface pour calculer le volume et les débits d'air.",
      indoorTemp:
        "La température de la zone au début de la simulation. Ce n'est pas un point de consigne : les consignes de chauffage et de refroidissement se règlent dans le Planning de chauffage et le Planning de refroidissement.",
      tekStandard:
        "TEK désigne la réglementation norvégienne du bâtiment, par exemple TEK10 et TEK17, qui fixe des exigences notamment sur les valeurs U et l'étanchéité. Sélectionnez la norme TEK pertinente si vous souhaitez contrôler les valeurs standard plus précisément que l'année de construction seule ne le permet.",
      airLeakageN50:
        "Le taux de fuite d'air (n50) décrit l'étanchéité du bâtiment, mesurée en renouvellements d'air par heure à 50 Pa de différence de pression. Indiquez la valeur si elle est connue par un test de pressurisation ou de la documentation. Si le champ est vide, des valeurs standard représentatives sont utilisées.",
      thermalBridgeCoeff:
        'Un pont thermique est un endroit de la construction où la déperdition de chaleur est accrue, généralement là où les planchers et les murs rejoignent la structure extérieure. Sélectionnez le système porteur ou la catégorie de pont thermique si vous souhaitez modéliser les ponts thermiques plus précisément. Normalement utilisé uniquement lorsque vous disposez de bonnes informations de physique du bâtiment.',
      thermalBridgePsiValue:
        'La valeur normalisée de pont thermique (ψ) exprime la déperdition de chaleur supplémentaire totale due aux ponts thermiques par m² de surface de plancher. Indiquez la valeur si elle est connue par calcul. Peut normalement rester vide dans un relevé standard.',
      heatingEmissionSystem:
        "Le système d'émission de chaleur est la manière dont la chaleur est délivrée à la pièce, par exemple radiateur, convecteur ou plancher chauffant. Le choix influe sur la température de départ requise et la régulation. Utile pour le détail, mais généralement pas nécessaire lors du premier enregistrement.",
      coolingEmissionSystem:
        "Le système d'émission de froid est la manière dont le froid est délivré à la pièce, par exemple poutre froide, ventilo-convecteur ou plafond rafraîchissant. Le choix influe sur le niveau de température et la régulation. Utile pour le détail, mais généralement pas nécessaire lors du premier enregistrement.",
      zoneConnections:
        'Une connexion de zone décrit une surface où deux zones, ou une zone et une condition climatique, échangent de la chaleur, par exemple un mur intérieur donnant sur une zone plus froide. Utilisez ceci lorsque cet échange de chaleur est important pour le modèle. Normalement pertinent uniquement dans une configuration plus détaillée.',
      connectionArea:
        'Indiquez la surface en m² de la face qui relie les zones. Avec la valeur U, elle détermine la quantité de chaleur échangée. À ne remplir que lorsque vous modélisez réellement une connexion de zone.',
      connectionUValue:
        'La valeur U décrit le pouvoir isolant de la face entre les zones (W/m²K). Indiquez-la si vous en disposez. Sinon, la connexion peut généralement être simplifiée ou omise.',
      heatingSchedule:
        'Un programme de chauffage décrit comment la consigne et le fonctionnement varient au cours de la journée et de la semaine, par exemple un abaissement nocturne. Utilisez-le lorsque la zone a un fonctionnement variable. Donne une simulation plus réaliste que des profils standard fixes.',
      hasFloorToGround:
        "Activez ceci si la zone a un plancher sur le sol. La désactivation masque l'élément et retire la surface enregistrée du calcul énergétique.",
      hasRoof:
        "Activez ceci si la zone a un toit donnant sur l'extérieur. La désactivation masque l'élément et retire la surface enregistrée du calcul énergétique.",
      isBasement:
        "Activez ceci lorsque la zone est un sous-sol sous le niveau du terrain. La déperdition vers le sol est alors calculée à partir de l'élément Construction du sous-sol, et le toit, le plancher sur sol, les murs extérieurs, les fenêtres et les portes de cette zone sont exclus du calcul énergétique.",
      basement: {
        area: 'Saisissez la surface de plancher du sous-sol contre le sol en m². Elle est nécessaire au calcul de la déperdition vers le sol et correspond normalement à la BRA de la zone de sous-sol.',
        wallPerimeter:
          'Saisissez la longueur en mètres de mur de sous-sol en contact avec le sol. Avec la surface, elle donne la dimension caractéristique du plancher. Si le champ est vide, une emprise carrée est supposée.',
        fillHeight:
          "Saisissez la profondeur moyenne du terrain jusqu'au plancher du sous-sol en mètres. Elle détermine la part du mur qui cède de la chaleur au sol. 0 signifie dalle sur terre-plein.",
        wallThickness:
          "Saisissez l'épaisseur totale du mur de sous-sol au niveau du terrain en mètres, isolation comprise. 0,3 m est utilisé si le champ est vide.",
        wallConstructionType:
          'Sélectionnez la construction du mur de sous-sol enterré, ou une période TEK pour utiliser son exigence. Le choix suggère la valeur U.',
        wallUValue:
          "La valeur U de la construction du mur de sous-sol enterré (W/m²K). Saisissez-la si vous la connaissez d'après la documentation, sinon la valeur suggérée est utilisée.",
        floorConstructionType:
          'Sélectionnez la construction du plancher de sous-sol contre le sol, ou une période TEK pour utiliser son exigence. Le choix suggère la valeur U.',
        floorUValue:
          "La valeur U de la construction du plancher de sous-sol contre le sol (W/m²K). Saisissez-la si vous la connaissez d'après la documentation, sinon la valeur suggérée est utilisée.",
      },
      floor: {
        type: "Le type de plancher sur le sol décrit comment le plancher vers le sol ou vers un espace non chauffé est constitué, par exemple dalle sur terre-plein ou plancher au-dessus d'une cave. Sélectionnez celui qui décrit le mieux la construction. Le choix sert à proposer des valeurs standard pertinentes, dont la valeur U.",
        area: 'Indiquez la surface du plancher sur le sol en m² pour la partie de la zone à enregistrer. La surface est nécessaire pour calculer les déperditions de chaleur à travers le plancher.',
        uValue:
          "La valeur U indique la quantité de chaleur qui traverse la construction par m² et par degré de différence de température (W/m²K). Une valeur plus faible signifie une meilleure isolation. Indiquez-la si vous la connaissez par documentation ou calcul, sinon des valeurs nominales basées sur le type et l'année sélectionnés sont utilisées.",
      },
      structuralNodes: {
        boundary:
          'Un nœud structurel est un endroit où des éléments du bâtiment se rejoignent, par exemple entre un plancher et un mur extérieur, et constitue généralement un pont thermique avec une déperdition de chaleur supplémentaire. Utilisez les nœuds structurels lorsque vous souhaitez enregistrer de tels détails. Normalement pertinent uniquement à un niveau de détail plus élevé.',
        length:
          'Indiquez la longueur du nœud ou du pont thermique concerné en mètres. À remplir uniquement si des nœuds structurels sont utilisés.',
        height:
          'Indiquez la hauteur du nœud concerné en mètres si pertinent. Utilisée avec les autres dimensions pour une description géométrique détaillée.',
        width:
          "Indiquez la largeur du nœud concerné en mètres si pertinent. Ce champ n'est utilisé que pour l'enregistrement détaillé des nœuds structurels.",
      },
      roof: {
        angle:
          "L'angle de toiture est la pente de la surface du toit en degrés, 0 correspondant à un toit plat. Il est enregistré pour l'inspection, mais le calcul énergétique ne l'utilise pas encore : la déperdition par la toiture est calculée à partir de la surface et du coefficient U, et les fenêtres de toit ne reçoivent pas d'apport solaire dans le calcul.",
        type: 'La construction de la toiture décrit comment le toit est constitué, par exemple toiture compacte, toiture en pente ventilée ou fermes. Sélectionnez celle qui décrit le mieux le toit. Le choix sert de base à la valeur U standard et aux autres hypothèses.',
        area: 'Indiquez la surface de toiture en m² incluse dans la zone. La surface est nécessaire pour calculer la transmission à travers le toit.',
        uValue:
          "La valeur U indique la quantité de chaleur qui traverse la construction de toiture par m² et par degré de différence de température (W/m²K). Une valeur plus faible signifie une meilleure isolation. Indiquez-la si elle est connue, sinon une valeur nominale basée sur la construction et l'âge sélectionnés est utilisée.",
        glassType:
          "Activez ceci si le toit comporte des fenêtres ou des lanterneaux, et sélectionnez le type de vitrage. Le type de vitrage, par exemple double ou triple, détermine à la fois la déperdition de chaleur et la quantité d'énergie solaire qui pénètre par la surface du toit.",
        windowArea:
          "Indiquez la surface totale des fenêtres ou des lucarnes en m². Ce champ n'est pertinent que si le toit comporte effectivement des fenêtres ou des lucarnes.",
        windowUValue:
          'La valeur U des fenêtres de toit indique la déperdition de chaleur à travers le vitrage et le cadre eux-mêmes (W/m²K). Une valeur plus faible signifie une meilleure isolation. Indiquez-la si elle est connue, sinon les valeurs standard sont souvent suffisantes.',
        gValue:
          "La valeur g (facteur solaire) décrit la proportion d'énergie solaire qui traverse le vitrage, de 0 à 1. Une valeur g élevée apporte plus de chaleur solaire gratuite en hiver, mais aussi un besoin de refroidissement plus important en été.",
        externalBlindsGt:
          "Les stores extérieurs sont montés à l'extérieur du vitrage et réduisent efficacement le rayonnement solaire. Le facteur solaire (gt) décrit la quantité d'énergie solaire qui passe lorsque la protection est active. Enregistrez ceci lorsque cette protection solaire a un effet net.",
        externalScreenGt:
          "Un écran extérieur est une protection textile extérieure qui atténue le rayonnement solaire. Le facteur solaire (gt) indique la quantité d'énergie solaire qui passe lorsque la toile est descendue. À ne remplir que si la solution existe dans le bâtiment.",
        internalShadingGt:
          "La protection solaire intérieure, par exemple stores ou rideaux à l'intérieur, atténue le soleil mais de façon moins efficace que la protection extérieure. Le facteur solaire (gt) décrit l'apport solaire restant. Utilisé pour améliorer le calcul des apports solaires.",
      },
      groundConditions: {
        type: "Les conditions du sol décrivent les masses sous le bâtiment, par exemple argile, sable ou roche, qui influencent la déperdition de chaleur vers le sol. Utilisez ceci lorsque vous disposez d'informations spécifiques sur le sol. Il s'agit généralement d'un champ de détail.",
        thermalConductivity:
          'La conductivité thermique (λ) indique dans quelle mesure le sol conduit la chaleur, en W/mK. Une valeur plus élevée entraîne une déperdition de chaleur plus importante vers le sol. Indiquez une valeur documentée si vous en disposez, sinon le champ peut rester vide.',
        heatCapacity:
          'La capacité thermique décrit la quantité de chaleur que le sol peut stocker et atténue les fluctuations de la déperdition de chaleur dans le temps. Indiquez-la si elle est connue. Peut normalement rester vide dans un relevé énergétique ordinaire.',
        penetrationDepth:
          "La profondeur de pénétration périodique est la profondeur dans le sol affectée par les variations saisonnières de température. Elle est utilisée dans des modèles de sol plus détaillés. Le champ n'est généralement pas nécessaire dans un enregistrement standard.",
      },
      internalLoads: {
        lighting:
          "L'éclairage est un apport de chaleur interne : l'énergie utilisée par les sources lumineuses se transforme en grande partie en chaleur dans la zone. Enregistrez le niveau d'éclairage et les éventuels profils de fonctionnement. Cela influence à la fois la consommation d'électricité et le besoin de refroidissement.",
        equipment:
          "Les équipements techniques tels que les ordinateurs, les écrans et autres équipements fixes dégagent de la chaleur dans la pièce en plus de consommer de l'électricité, et constituent donc un apport de chaleur interne. Enregistrez la puissance typique et le profil de fonctionnement de la zone.",
        occupancy:
          "Les personnes dégagent de la chaleur et de l'humidité et influencent en même temps le besoin de ventilation. Enregistrez l'occupation par des nombres et des profils ou une configuration standard décrivant l'utilisation normale de la zone.",
        dishwasher:
          "Cochez le lave-vaisselle s'il constitue une charge pertinente dans la zone. La part d'eau chaude indique quelle quantité de la consommation est couverte par l'eau chaude sanitaire plutôt que par le chauffage propre de l'appareil. Normalement utilisé uniquement lorsque les appareils sont importants.",
        washingMachine:
          "Cochez le lave-linge s'il constitue une charge pertinente dans la zone. La part d'eau chaude indique quelle quantité d'eau la machine puise dans le système d'eau chaude au lieu de la chauffer elle-même.",
        tumbleDryer:
          "Cochez le sèche-linge s'il constitue une charge pertinente dans la zone. Une éventuelle part d'eau chaude décrit quelle quantité du besoin énergétique est couverte par l'eau chaude sanitaire plutôt que par l'électricité directe.",
      },
      thermalMass: {
        heatCapacityCategory:
          'La masse thermique est la capacité du bâtiment à stocker la chaleur, ce qui atténue les variations de température et décale dans le temps les besoins de chauffage et de refroidissement. Sélectionnez une catégorie de capacité thermique, par exemple construction légère ou lourde, si vous souhaitez ajuster cela au-delà des valeurs standard.',
        normalizedHeatCapacity:
          'La capacité thermique normalisée exprime la quantité de chaleur que la zone peut stocker par m² de surface de plancher (Wh/m²K). Indiquez une valeur plus précise si vous en disposez, sinon le champ peut rester vide et la catégorie est utilisée.',
        cladding:
          'Le revêtement intérieur, par exemple plaque de plâtre, bois ou béton apparent, influence la part de la masse thermique réellement active vis-à-vis de la pièce. Sélectionnez le type si vous souhaitez une description plus détaillée.',
        heatCapacity:
          "Indiquez la capacité thermique des murs intérieurs si elle est connue. Cela décrit la quantité de chaleur que les constructions intérieures peuvent stocker et n'est utilisé que pour une modélisation plus détaillée de la masse thermique.",
        furnitureGrade:
          "Le mobilier et les aménagements contribuent également à la masse thermique. Sélectionnez un degré d'ameublement décrivant à quel point la zone est meublée si cela a de l'importance. Le champ est normalement un champ de détail.",
        massFactor:
          'Le facteur de masse ajuste la contribution du mobilier et des aménagements à la masse thermique de la zone. Indiquez une valeur si vous souhaitez remplacer la valeur standard.',
      },
      exteriorWall: {
        direction:
          "L'orientation détermine la quantité de soleil que reçoit la façade et la manière dont le vent et le climat extérieur influencent la déperdition de chaleur. Sélectionnez la direction, par exemple nord, sud, est ou ouest, pour le mur enregistré.",
        type: 'Le type de mur décrit comment le mur extérieur est constitué, par exemple ossature bois, maçonnerie ou béton avec isolation. Sélectionnez celui qui décrit le mieux le mur. Le choix sert à proposer des valeurs standard pertinentes.',
        area: 'Saisissez la surface brute du mur extérieur en m², fenêtres, portes et portails compris. Le calcul déduit lui-même les ouvertures enregistrées sur le mur ; une surface nette sous-estimerait la déperdition par le mur.',
        uValue:
          "La valeur U indique la quantité de chaleur qui traverse le mur par m² et par degré de différence de température (W/m²K). Une valeur plus faible signifie une meilleure isolation. Indiquez-la si elle est connue, sinon des valeurs nominales basées sur le type de mur et l'âge sont utilisées.",
        windowShadingFactor:
          "La part du rayonnement solaire direct que la fenêtre perd à cause de l'ombrage (débords, bâtiments voisins, relief), de 0 à 1. 0 signifie aucun ombrage et 1 un ombrage total. Seul le soleil direct est réduit, pas le rayonnement diffus. Les stores et screens ci-dessous sont enregistrés mais ne sont pas utilisés dans le calcul.",
      },
      heatingCooling: {
        name: "Donnez à l'équipement un nom clair qui permet de distinguer facilement les composants. Le nom sert principalement à l'identification dans le projet.",
        type: "Le type décrit de quel genre d'unité de chauffage ou de refroidissement il s'agit, par exemple radiateur, plancher chauffant, pompe à chaleur ou poutre froide. Le choix détermine quels champs sont pertinents et comment le système est modélisé.",
        energySource:
          "La source d'énergie est ce que l'unité utilise pour produire du chauffage ou du refroidissement, par exemple électricité, réseau de chaleur ou pompe à chaleur. Sélectionnez la source si le composant est directement raccordé à une source spécifique, sinon l'approvisionnement énergétique peut être décrit de manière centralisée.",
        co2eEmissionFactor:
          "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre associée à l'énergie utilisée par l'unité, exprimée par kWh. Indiquez une valeur spécifique si vous souhaitez calculer les émissions avec précision. Il n'affecte pas le besoin énergétique lui-même.",
        quantity:
          "Indiquez le nombre d'unités identiques si plusieurs unités identiques sont installées. Peut rester vide si la puissance est indiquée globalement.",
        power:
          "La puissance nominale est la puissance maximale de chauffage ou de refroidissement de l'unité en kW. Elle sert à évaluer si le système a la capacité de couvrir le besoin et comment plusieurs systèmes sont priorisés. Indiquez la puissance totale si plusieurs unités identiques sont regroupées.",
        systemEfficiency:
          "Le rendement du système décrit la part de l'énergie fournie qui devient réellement du chauffage ou du refroidissement utile, y compris les pertes de distribution et de régulation. Indiquez une meilleure valeur que la valeur standard si vous en disposez. Souvent pas nécessaire lors du premier enregistrement.",
        priority:
          "La priorité détermine l'ordre dans lequel les systèmes sont mis en service lorsque plusieurs couvrent le même besoin. Une priorité plus basse signifie que le système est utilisé en premier, et le reste couvre la charge de pointe. Définissez ceci si la zone comporte plusieurs sources de chauffage ou de refroidissement.",
        cop: "Le COP (Coefficient of Performance) est le rendement de la pompe à chaleur pour le chauffage : le rapport entre la chaleur fournie et l'électricité consommée. Un COP de 3 signifie trois fois plus de chaleur que d'électricité. Indiquez une valeur spécifique si vous en disposez.",
        eer: "L'EER (Energy Efficiency Ratio) est le rendement pour le refroidissement : le rapport entre le froid fourni et l'électricité consommée. Une valeur plus élevée signifie un refroidissement plus efficace. Indiquez une valeur spécifique si vous en disposez.",
        nominalLoad:
          "La charge nominale (0-1) décrit la part de la pleine capacité à laquelle l'unité est dimensionnée pour fonctionner normalement. Il s'agit d'un champ de détail qui peut généralement rester à la valeur standard.",
        minimumLoad:
          "La charge minimale (0-1) est la part la plus faible de la pleine capacité à laquelle l'unité peut fonctionner de manière stable avant de devoir s'arrêter et redémarrer. Indiquez une valeur si vous souhaitez remplacer la valeur standard.",
        degradeCoeff:
          "Le coefficient de dégradation (0-1) décrit dans quelle mesure le rendement baisse lorsque l'unité fonctionne à charge partielle plutôt qu'à pleine puissance. Les unités à régulation par onduleur ont généralement des pertes plus faibles. Souvent défini automatiquement.",
        maxTemperatureSupplied:
          "La température de départ maximale est la température la plus élevée que l'unité peut fournir au système d'émission de chaleur. Elle détermine si l'unité peut couvrir le besoin de température, par exemple pour des radiateurs nécessitant une température de départ élevée.",
      },
      domesticHotWater: {
        name: "Donnez un nom clair au composant d'eau chaude sanitaire si vous enregistrez plusieurs unités ou sous-systèmes.",
        heaterType:
          "Le type de chauffe décrit comment l'eau chaude sanitaire est chauffée, par exemple un chauffe-eau électrique direct, une pompe à chaleur ou une alimentation centrale comme un réseau de chaleur. Le choix influe à la fois sur le besoin énergétique et les émissions pour l'eau chaude.",
        tapFrequency:
          "La fréquence de puisage décrit à quelle fréquence et en quelle quantité l'eau chaude est puisée, et reflète le mode d'utilisation réel de la zone. C'est un facteur important du besoin énergétique calculé pour l'eau chaude.",
        tapCyclesPerDay:
          "Le nombre de cycles de puisage par jour correspond au nombre de fois où l'eau chaude est puisée au cours d'une journée. Indiquez une valeur si vous souhaitez remplacer le profil standard par un chiffre plus précis.",
        thermalZone:
          "Reliez le système d'eau chaude sanitaire à la zone thermique qu'il dessert. Cela place correctement la consommation d'énergie et l'éventuelle émission de chaleur dans le modèle.",
      },
      productionEquipment: {
        name: "Donnez un nom clair à l'équipement de production. Sert à identifier la charge dans le projet et dans les rapports.",
        energySource:
          "La source d'énergie est ce que l'équipement de production utilise, par exemple électricité ou gaz. Elle sert à répartir la consommation d'énergie sur le bon vecteur et à un éventuel calcul des émissions.",
        power:
          "La puissance nominale est la puissance absorbée typique de l'équipement en kW. Avec le programme de fonctionnement, elle constitue la base du calcul de la consommation d'énergie et de l'émission de chaleur vers la zone.",
        eligibleForHarvesting:
          "La récupération d'énergie consiste à utiliser la chaleur excédentaire de l'équipement à d'autres fins, par exemple le chauffage. Cochez ceci si l'équipement émet un tel surplus d'énergie, afin que le potentiel de récupération soit évalué.",
        operationalSchedule:
          "Le programme de fonctionnement décrit quand l'équipement est réellement utilisé au cours de la journée et de la semaine. Ajoutez-le si l'équipement ne suit pas les heures de fonctionnement normales, pour un calcul plus réaliste de la consommation d'énergie et des charges internes.",
      },
      hvac: {
        name: "Donnez à la centrale de ventilation un nom clair. Le nom sert à l'identification si le bâtiment comporte plusieurs centrales.",
        linkedZones:
          "Les zones reliées sont les zones thermiques que la centrale de ventilation dessert en air. Le choix est nécessaire pour répartir correctement les débits d'air, l'énergie des ventilateurs et la récupération de chaleur entre les zones.",
        flowSfpSettings:
          "Vous saisissez ici les débits d'air et les hypothèses SFP de la centrale. Le SFP (puissance de ventilation spécifique) exprime la puissance électrique que les ventilateurs utilisent par débit d'air, et constitue une information essentielle pour le calcul de la ventilation.",
        motorType:
          "Le type de moteur, par exemple AC ou EC, influe sur le rendement du ventilateur et la façon dont la puissance varie à charge partielle. Sélectionnez le type s'il est connu pour un calcul plus précis.",
        sfp100:
          "Le SFP (puissance de ventilation spécifique) est le rapport entre la puissance absorbée des ventilateurs et le débit d'air, exprimé en kW par m³/s. Un SFP plus faible signifie un ventilateur plus efficace énergétiquement. Indiquez la valeur à 100 % de fonctionnement, c'est le paramètre principal du calcul de la ventilation.",
        sfp80:
          "Le SFP à 80 % de fonctionnement décrit la puissance de ventilation spécifique lorsque la centrale fonctionne à débit d'air réduit. Indiquez-le si vous disposez de données de charge partielle, sinon le champ peut rester vide.",
        sfp60:
          "Le SFP à 60 % de fonctionnement décrit la puissance de ventilation spécifique à un débit d'air plus faible. Utilisé uniquement pour une modélisation plus détaillée de la charge partielle.",
        sfp40:
          "Le SFP à 40 % de fonctionnement. Indiquez-le si des données de charge partielle pour un débit d'air aussi faible sont disponibles.",
        sfp20:
          "Le SFP à 20 % de fonctionnement. Indiquez-le si des données de charge partielle pour un débit d'air aussi faible sont disponibles.",
        fanPowerIn:
          "La puissance du ventilateur de soufflage est la puissance électrique absorbée du ventilateur de soufflage en kW. Indiquez-la si vous l'avez séparément. Peut normalement rester vide lorsque le SFP est renseigné, car la puissance en est alors calculée.",
        fanPowerOut:
          "La puissance du ventilateur d'extraction est la puissance électrique absorbée du ventilateur d'extraction en kW. Indiquez-la si vous l'avez séparément. Utilisé uniquement pour un relevé plus détaillé.",
        coverageArea:
          "La surface de couverture est la surface de plancher que la centrale dessert en m². Indiquez-la si la centrale ne couvre qu'une partie du bâtiment ou de la zone. Peut souvent être déduite des zones associées.",
        coverageVolume:
          "Le volume de couverture est le volume d'air que la centrale dessert en m³. Indiquez-le s'il est connu. Utilisé comme champ de détail pour le dimensionnement de la ventilation.",
        airVolumeOperating:
          "Le débit d'air soufflé en fonctionnement est le débit d'air que la centrale fournit en fonctionnement normal, en m³/h. C'est une donnée d'entrée essentielle pour le besoin de ventilation, l'énergie des ventilateurs et les batteries chaud et froid.",
        airVolumeCapacity:
          "La capacité d'air soufflé est le débit d'air maximal que la centrale peut fournir, en m³/h. Indiquez-la si elle est connue. Utile pour les évaluations de capacité, mais pas toujours nécessaire.",
        airVolumeNonOperating:
          "Le débit d'air soufflé hors fonctionnement est le débit d'air que la centrale fournit lorsque le bâtiment n'est pas utilisé, par exemple en fonctionnement de nuit réduit. Indiquez-le si la centrale fonctionne avec un débit d'air réduit une partie du temps.",
        airVolumeExtractionOperating:
          "Le débit d'air extrait en fonctionnement est l'air que la centrale extrait des zones en fonctionnement normal, en m³/h. Avec le débit d'air soufflé, il décrit l'équilibre d'air réel de la centrale et influe sur l'énergie des ventilateurs et la récupération de chaleur.",
        airVolumeExtractionCapacity:
          "La capacité d'air extrait est le débit d'air maximal que la centrale peut extraire, en m³/h. Indiquez-la si elle est connue. Utile pour les évaluations de capacité, mais pas toujours nécessaire.",
        airVolumeExtractionNonOperating:
          "Le débit d'air extrait hors fonctionnement est l'air que la centrale extrait lorsque le bâtiment n'est pas utilisé, par exemple en abaissement nocturne ou fonctionnement réduit. Indiquez-le si la centrale fonctionne avec un débit d'air réduit une partie du temps.",
        supplyTemperature:
          "La température d'air soufflé est la température de l'air que la centrale insuffle dans la zone, en °C. Les consignes du planning opérationnel sont prioritaires : cette valeur n'est utilisée que pour les heures où le planning n'a pas de consigne. Pour modifier la consigne de soufflage, modifiez-la dans le planning opérationnel.",
        heatRecoveryType:
          "La récupération de chaleur réutilise la chaleur de l'air extrait pour préchauffer l'air soufflé, ce qui réduit le besoin de chauffage. Sélectionnez le type installé, par exemple roue thermique, échangeur à plaques ou batterie à eau glycolée. Le choix est important pour le calcul de l'énergie récupérée.",
        efficiencyHR:
          "Le rendement indique quelle proportion de la chaleur de l'air extrait l'unité de récupération transfère réellement à l'air soufflé, en pourcentage. Une valeur plus élevée signifie un besoin de chauffage plus faible. Indiquez une valeur documentée si vous en disposez, sinon une valeur standard basée sur le type sélectionné est utilisée.",
        frostProtection:
          "La protection antigel empêche l'unité de récupération de givrer par basses températures extérieures, mais peut réduire la quantité de chaleur récupérée pendant ces périodes. Cochez ceci si la centrale dispose d'une protection antigel qui influe sur le fonctionnement ou la récupération de chaleur. Utile pour une modélisation plus précise.",
        frostProtectionTemperature:
          "Il s'agit de la température extérieure à laquelle la protection antigel s'active. En dessous de cette température, la récupération est réduite ou régulée pour éviter le givrage. Indiquez la valeur si elle est connue, sinon une valeur standard est utilisée.",
        measuredSupplyTemp:
          "La température d'air soufflé mesurée est la température réelle de l'air que la centrale insuffle, relevée lors d'une visite ou d'un enregistrement. Indiquez-la si vous disposez de mesures sur site. Utilisée pour l'assurance qualité et un calage plus précis du modèle.",
        measuredExhaustTemp:
          "La température d'air extrait mesurée est la température réelle de l'air extrait des zones, relevée par mesure sur site. Indiquez-la si vous disposez de telles mesures. Avec la température d'air soufflé mesurée, elle sert à l'assurance qualité.",
        dx: {
          name: "Un système DX (détente directe) est une batterie de froid ou de pompe à chaleur où le fluide frigorigène s'évapore directement dans le flux d'air, sans circuit d'eau intermédiaire. Donnez à l'unité un nom clair pour l'identification si la centrale comporte une telle unité DX intégrée.",
          type: "Le type indique ce que l'unité DX peut faire : refroidissement seul, chauffage seul, ou les deux (fonction pompe à chaleur). Le choix détermine quels champs de puissance et de rendement sont pertinents.",
          heatingEffect:
            "La puissance de chauffage est la chaleur maximale que l'unité DX peut fournir à l'air, en kW. Indiquez-la si le système fournit de la chaleur. Peut rester vide si l'unité est utilisée uniquement pour le refroidissement.",
          coolingEffect:
            "La puissance de refroidissement est le froid maximal que l'unité DX peut fournir à l'air, en kW. C'est normalement la valeur de capacité la plus importante pour le fonctionnement en refroidissement.",
          seasonalCop:
            "Le COP saisonnier est le rendement moyen de l'unité DX pour le chauffage sur une saison : le rapport entre la chaleur fournie et l'électricité consommée. Indiquez-le si l'unité est aussi utilisée pour le chauffage. Utilisez une valeur standard si une documentation précise n'est pas disponible.",
          seasonalEer:
            "L'EER saisonnier est le rendement moyen de l'unité DX pour le refroidissement sur une saison : le rapport entre le froid fourni et l'électricité consommée. Indiquez-le s'il est connu. Sert à calculer la consommation d'électricité pour le refroidissement.",
          systemEfficiency:
            "Le calcul utilise le rendement du système comme rendement de l'unité DX elle-même, en pourcentage : 300 % signifie trois fois plus de chaleur ou de froid que d'électricité. Les champs COP/EER saisonniers ne sont pas encore utilisés ; saisissez donc ici le COP ou l'EER en pourcentage. Laissé vide, 100 % est utilisé.",
          energySource:
            "La source d'énergie est ce que l'unité DX utilise pour produire du chauffage ou du refroidissement, normalement l'électricité. Elle sert à la répartition de l'énergie et à un éventuel calcul des émissions.",
        },
        heatingBattery: {
          name: "Une batterie chaude en ventilation est un échangeur de chaleur dans la centrale qui réchauffe l'air soufflé, généralement alimenté en eau chaude depuis une chaudière ou une pompe à chaleur, ou électrique. Donnez à la batterie un nom clair si plusieurs batteries existent dans la même centrale ou le même bâtiment.",
          type: "Le type de batterie indique comment la chaleur est fournie, par exemple à eau (eau chaude traversant la batterie) ou électrique. Le choix influe sur la source d'énergie et le rendement.",
          power:
            "La puissance est la chaleur maximale que la batterie peut apporter à l'air soufflé, en kW. Utilisée pour le contrôle de capacité et le calcul énergétique.",
          systemEfficiency:
            "Le rendement du système prend en compte les pertes de distribution et de régulation jusqu'à la batterie. Indiquez une valeur si vous avez un meilleur chiffre que la valeur standard, sinon le champ peut rester vide.",
          energySource:
            "La source d'énergie est ce qui alimente la batterie chaude en chaleur, par exemple réseau de chaleur, chaudière, pompe à chaleur ou électricité. Elle sert à la répartition de l'énergie et à un éventuel calcul des émissions.",
        },
        coolingBattery: {
          name: "Une batterie froide en ventilation est un échangeur de chaleur dans la centrale qui refroidit l'air soufflé, généralement alimenté en eau glacée depuis un groupe froid ou par détente directe (DX). Donnez à la batterie un nom clair si plusieurs batteries existent.",
          type: "Le type indique comment le froid est fourni, par exemple à eau (eau glacée traversant la batterie) ou DX (détente directe). Le choix influe sur la source d'énergie et le rendement.",
          power:
            "La puissance est le froid maximal que la batterie peut apporter à l'air soufflé, en kW. Utilisée pour le contrôle de capacité et le calcul énergétique.",
          systemEfficiency:
            'Le rendement du système prend en compte les pertes supplémentaires de distribution et de régulation au-delà de la performance nominale. Indiquez une valeur si vous souhaitez inclure ces pertes, sinon le champ peut rester vide.',
          eer: "L'EER (Energy Efficiency Ratio) est le rendement de la batterie froide : le rapport entre le froid fourni et l'électricité consommée. Indiquez-le s'il est connu. Sert à calculer la consommation d'électricité pour le refroidissement.",
          energySource:
            "La source d'énergie est ce qui alimente la batterie froide en froid, par exemple un groupe froid, du froid urbain ou DX. Elle sert à la répartition de l'énergie et à un éventuel calcul des émissions.",
        },
        naturalVentilation:
          "La ventilation naturelle est un renouvellement d'air provoqué par le vent et les différences de température, à travers fenêtres, grilles ou conduits, sans ventilateurs. Activez ceci si la zone ou la centrale dispose d'une ventilation naturelle à inclure dans le modèle.",
        operationalSchedule:
          "Un programme de fonctionnement décrit quand la ventilation fonctionne au cours de la journée et de la semaine. Saisissez un programme pour la ventilation naturelle ou le fonctionnement de la centrale si celui-ci s'écarte des heures de fonctionnement standard.",
        operationalScheduleExtra:
          'Utilisez un programme supplémentaire lorsque la même centrale ou fonction de ventilation comporte plusieurs périodes de fonctionnement différentes, par exemple selon les saisons. Chaque programme couvre sa propre période.',
      },
      centralEnergy: {
        name: "Un module d'énergie centralisée est une centrale énergétique commune qui alimente plusieurs zones ou fonctions, par exemple une centrale de chauffage ou une centrale de production de froid. Donnez-lui un nom clair. Le nom sert uniquement à l'identification.",
        mode: "Le mode indique si la centrale fournit du chauffage, du refroidissement, de l'eau chaude ou des combinaisons de ces éléments. C'est un réglage fondamental qui détermine comment la centrale est utilisée dans le modèle.",
        thermalZone:
          "Une centrale peut être reliée à une zone thermique afin que la température ambiante autour de la centrale suive cette zone, ce qui influe sur le rendement et les pertes. Reliez-la à une zone pertinente si l'emplacement ou la température ambiante est important pour le calcul, sinon elle peut rester autonome.",
        ambientTemperature:
          "La température ambiante est la température du local où se trouve la centrale, par exemple un local technique. Elle n'est utilisée que lorsque la centrale n'est pas reliée à une zone thermique et influe sur les pertes de la centrale et des réservoirs de stockage. Si une zone est sélectionnée, la température en est tirée à la place.",
        sourceName:
          "Donnez à la source d'énergie un nom clair afin qu'elle soit facile à reconnaître si la centrale comporte plusieurs sources d'énergie. Le nom sert uniquement à l'identification.",
        usage:
          "Ces options déterminent ce que la source d'énergie couvre réellement : chauffage, refroidissement et/ou eau chaude sanitaire. Sélectionnez les besoins auxquels la source contribue. À régulation par onduleur signifie que l'unité peut moduler sa puissance, ce qui donne un meilleur rendement à charge partielle.",
        heatPump: {
          type: "Le type de pompe à chaleur décrit d'où la pompe à chaleur tire l'énergie et où elle la délivre : air-eau prend l'énergie de l'air extérieur et la délivre à un système à eau, eau glycolée-eau puise dans le sol, la roche ou l'eau via un capteur, et air-air chauffe directement l'air intérieur. Le choix influe sur le rendement et sur les champs supplémentaires affichés.",
          co2eEmissionFactor:
            "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre associée à l'énergie utilisée par la pompe à chaleur, exprimée par kWh. N'indiquez une valeur spécifique que si vous souhaitez calculer les émissions avec précision. Il n'affecte pas le besoin énergétique lui-même.",
          heatingCapacity:
            "La capacité de chauffage est la puissance thermique nominale de la pompe à chaleur en kW, c'est-à-dire la quantité de chaleur qu'elle peut fournir dans des conditions normales. C'est la valeur de capacité la plus importante et elle sert à évaluer si la pompe couvre le besoin de chauffage.",
          nominalLoad:
            "La charge nominale (0-1) est la part de la pleine capacité à laquelle la pompe à chaleur est dimensionnée pour fonctionner normalement. Indiquez-la si la documentation l'indique séparément. Utilisée pour une modélisation détaillée à charge partielle.",
          minimumLoad:
            "La charge minimale (0-1) est la part la plus faible de la pleine capacité à laquelle la pompe à chaleur peut fonctionner de manière stable avant de devoir s'arrêter et redémarrer. Indiquez-la si la pompe peut moduler et que cela est connu.",
          degradeCoeff:
            "Le coefficient de dégradation (0-1) décrit dans quelle mesure le rendement baisse lorsque la pompe à chaleur fonctionne à charge partielle plutôt qu'à pleine puissance. Indiquez-le si des données constructeur ou des calculs sont disponibles. Peut normalement rester vide ; il est alors fixé à 0,8 selon NS 3031, ou 0,6 pour les unités à régulation par onduleur.",
          maxTemperatureSupplied:
            'La température la plus élevée fournie est la température de départ la plus chaude que la pompe à chaleur peut fournir au système de chauffage, en °C. Les pompes à chaleur perdent en rendement à des températures de départ élevées. Sert à évaluer si la pompe couvre le besoin de température, par exemple pour des radiateurs nécessitant une température élevée.',
          cop: "Le COP (Coefficient of Performance) est le rendement de la pompe à chaleur pour le chauffage : le rapport entre la chaleur fournie et l'électricité consommée. Un COP de 3 signifie trois fois plus de chaleur que d'électricité. Indiquez une valeur spécifique si vous en disposez, sinon des valeurs standard sont utilisées.",
          liquidSource:
            "La source liquide est le milieu dont la pompe à chaleur eau glycolée-eau tire l'énergie via un capteur, par exemple le sol, la roche, l'eau douce ou l'eau de mer. La source influe sur la température de source disponible et donc sur le rendement.",
          sourceTemperature:
            'La température de source est la température du liquide provenant de la source et entrant dans la pompe à chaleur, en °C. Une température de source plus élevée donne un meilleur rendement. Indiquez-la si elle est connue par mesure ou étude de sol.',
          sourceYearlyAverageTemperature:
            'La température moyenne annuelle est la température moyenne de la source sur une année, en °C. Elle sert de référence pour calculer la performance saisonnière de la pompe à chaleur. Indiquez-la si elle est connue, sinon des valeurs typiques pour la source sélectionnée sont utilisées.',
          liquidMaxTemperature:
            "Il s'agit de la température la plus élevée que la source atteint au cours de l'année, en °C. Avec la moyenne annuelle et l'amplitude, elle décrit comment la température de source varie au fil de la saison, ce qui influe sur le rendement.",
          sourceTemperatureAmplitude:
            "L'amplitude de température décrit dans quelle mesure la température de source varie au-dessus et en dessous de la moyenne annuelle au cours de l'année, en °C. Une amplitude plus grande signifie une variation saisonnière du rendement plus importante. Indiquez-la si elle est connue, sinon des valeurs typiques pour la source sont utilisées.",
          energyWellDimensioning:
            "Valeurs indicatives pour la température moyenne annuelle et l'amplitude annuelle des puits géothermiques (forages). Choisissez la description qui correspond le mieux à l'utilisation et au dimensionnement du puits ; les valeurs de température sont alors définies automatiquement selon le climat local.",
          waterSourceDepth:
            "Valeurs indicatives pour la température moyenne annuelle et l'amplitude annuelle du prélèvement de chaleur en mer ou en eau douce. Choisissez la profondeur du prélèvement ; les valeurs de température sont alors définies automatiquement selon le climat local.",
        },
        districtHeating: {
          maxCapacity:
            "La capacité maximale est la puissance la plus élevée que le raccordement au réseau de chaleur ou de froid peut fournir au bâtiment, en kW. Indiquez-la si elle est connue d'après la documentation ou les données d'installation. Sert à évaluer si la source couvre le besoin de puissance.",
          efficiency:
            "Le rendement décrit la part de l'énergie fournie par le réseau de chaleur qui devient réellement de la chaleur utile dans le bâtiment, après les pertes dans l'échangeur et la distribution. Indiquez une valeur globale si vous souhaitez remplacer les valeurs standard de la centrale.",
          temperatureFromSource:
            "La température de la source est la température de départ que le réseau de chaleur ou de froid fournit à l'échangeur, en °C. Indiquez-la si elle est connue. Donne une description plus réaliste du fonctionnement et du rendement de la centrale.",
          heatExchangerLoss:
            "L'échangeur de chaleur transfère l'énergie du réseau de chaleur vers le système propre du bâtiment, et une partie de l'énergie est perdue en chemin. Sélectionnez le niveau d'isolation et la plage de température de sortie pour décrire la perte plus en détail, ou indiquez directement le coefficient de perte si une valeur documentée existe. Laissez les champs vides pour utiliser les valeurs standard.",
          distributionHeatLoss:
            "La perte de chaleur de distribution est l'énergie perdue dans le réseau de tuyauterie entre la centrale et le système du bâtiment. Sélectionnez la plage de température d'alimentation pour la distribution afin de décrire la perte plus en détail, ou indiquez directement le coefficient de perte s'il est connu. Laissez les champs vides pour utiliser les valeurs standard.",
          coolingHeatExchanger:
            "L'échangeur de froid transfère le froid du réseau de froid ou du groupe froid vers le système du bâtiment, et une partie de l'énergie est perdue. Sélectionnez le niveau d'isolation si le côté froid doit être modélisé plus en détail, ou indiquez directement la valeur U si elle est connue. Laissez les champs vides pour utiliser les valeurs standard.",
          co2eEmissionFactor:
            "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre associée à l'énergie du réseau de chaleur ou de froid, exprimée en grammes par kWh. Indiquez une valeur spécifique si vous souhaitez utiliser le chiffre d'émission réel du réseau. Il n'affecte que le bilan des émissions, pas le besoin énergétique lui-même.",
          energyPrice:
            "Le prix de l'énergie est le coût par kWh d'énergie fournie par le réseau de chaleur ou de froid. Indiquez un prix spécifique si vous souhaitez des calculs de coûts avec des prix réels, sinon le champ peut rester vide. Il n'affecte que les chiffres de coût, pas l'énergie ni les émissions.",
        },
        combustionBoiler: {
          boilerType:
            "Le type de chaudière décrit de quel genre de chaudière à combustion il s'agit, par exemple fioul, gaz ou biomasse. Sélectionnez celui qui décrit le mieux l'installation. Le choix détermine les hypothèses standard telles que le rendement et le niveau d'émission.",
          heatingCapacity:
            "La capacité de chauffage est la puissance thermique nominale de la chaudière en kW, c'est-à-dire la puissance qu'elle peut fournir dans des conditions normales. C'est la valeur principale pour évaluer si la chaudière couvre le besoin de puissance.",
          performance:
            "La performance indique le niveau de rendement nominal de la chaudière, c'est-à-dire l'efficacité avec laquelle le combustible est converti en chaleur utile. Sélectionnez ou indiquez le niveau s'il est documenté pour la chaudière, sinon des valeurs standard sont utilisées.",
          fuelSource:
            "La source de combustible est ce que la chaudière brûle, par exemple fioul, gaz ou biocombustible. Le choix détermine le contenu énergétique standard et le facteur d'émission du combustible, et influe donc à la fois sur le calcul énergétique et celui des émissions.",
          fuelEnergyContent:
            "Le contenu énergétique est la quantité d'énergie que contient le combustible par unité, par exemple kWh par litre. Indiquez une valeur spécifique si vous souhaitez des hypothèses plus précises que les valeurs standard du combustible sélectionné.",
          co2eEmissionFactor:
            "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre que produit la combustion du combustible, exprimée en grammes par kWh. Indiquez une valeur spécifique si vous souhaitez un calcul d'émissions précis. Il n'affecte que le bilan des émissions, pas le besoin énergétique.",
          efficiencyAtLowerLoad:
            "Il s'agit de la puissance thermique de la chaudière lorsqu'elle fonctionne à environ 30 % de la pleine charge, en kilowatts. La valeur est requise avec la valeur à pleine charge pour que la simulation modélise le comportement à charge partielle de la chaudière.",
          effectAtFullLoad:
            "Il s'agit de la puissance thermique de la chaudière à pleine charge en kilowatts, c'est-à-dire la puissance qu'elle fournit à son maximum. La valeur est requise pour que la simulation dimensionne correctement la chaudière.",
          isCondensing:
            "Une chaudière à condensation récupère aussi la chaleur de la vapeur d'eau des fumées et atteint ainsi un rendement plus élevé qu'une chaudière classique. Cochez ceci si la chaudière est à condensation.",
          isCHP:
            "Une centrale de cogénération (CHP) produit à la fois de l'électricité et de la chaleur en même temps à partir du même combustible, ce qui donne une utilisation énergétique globale élevée. Cochez ceci si l'installation est une centrale de cogénération ; des réglages CHP dédiés apparaissent alors.",
          scheduleStart:
            "L'heure de début correspond au moment où la saison de fonctionnement de la chaudière commence, indiquée en jour et mois. Renseignez ceci si la chaudière ne fonctionne pas en continu ou ne suit pas le profil de fonctionnement standard, par exemple une chaudière utilisée uniquement pendant la saison de chauffe.",
          scheduleEnd:
            "L'heure de fin correspond au moment où la saison de fonctionnement de la chaudière se termine, indiquée en jour et mois. À renseigner avec l'heure de début pour décrire la période pendant laquelle la chaudière fonctionne.",
          seasonalMeanTemp:
            "La température moyenne saisonnière est la température extérieure moyenne sur la saison de fonctionnement, en °C. Indiquez-la si l'installation doit être décrite avec des hypothèses de température plus détaillées que la valeur standard.",
          temperatureSupply:
            "La température de départ est la température de l'eau que la chaudière envoie vers le système de chauffage, en °C. Une température de départ plus basse donne souvent un meilleur rendement, surtout pour les chaudières à condensation. Indiquez-la si elle est connue.",
          temperatureReturn:
            "La température de retour est la température de l'eau qui revient à la chaudière depuis le système de chauffage, en °C. Pour les chaudières à condensation, une température de retour basse est importante pour obtenir la condensation et un rendement élevé. Indiquez-la si elle est connue.",
        },
        electricBoiler: {
          maxCapacity:
            "La capacité maximale est la puissance la plus élevée que la chaudière électrique peut fournir, en kW. C'est la valeur principale pour évaluer si la chaudière couvre le besoin de puissance.",
          insulationGrade:
            "Le degré d'isolation décrit dans quelle mesure la chaudière elle-même est isolée et détermine la quantité de chaleur qu'elle perd vers l'environnement lorsqu'elle est en marche. Sélectionnez un degré si vous souhaitez une modélisation plus précise de la déperdition de chaleur de la chaudière.",
          efficiency:
            "Le rendement décrit la part de l'électricité fournie qui devient de la chaleur utile, après les pertes dans la chaudière. Les chaudières électriques ont normalement un rendement élevé. Indiquez une valeur si vous souhaitez remplacer les hypothèses standard.",
          co2eEmissionFactor:
            "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre associée à l'électricité utilisée par la chaudière, exprimée en grammes par kWh. Indiquez une valeur spécifique si vous souhaitez un calcul d'émissions précis. Il n'affecte que le bilan des émissions, pas le besoin énergétique.",
          temperatureSupply:
            "La température de départ est la température de l'eau que la chaudière envoie vers le système de chauffage, en °C. Elle influe sur les émetteurs de chaleur que la chaudière peut alimenter et sur la déperdition de chaleur du système. Indiquez-la si elle est connue.",
          temperatureReturn:
            "La température de retour est la température de l'eau qui revient à la chaudière depuis le système de chauffage, en °C. Avec la température de départ, elle décrit le niveau de température du système. Indiquez-la si elle est connue.",
        },
        solarThermal: {
          solarType:
            "Le type de capteur solaire décrit le principe du capteur, par exemple capteur plan ou tube sous vide. Les capteurs à tubes sous vide offrent généralement de meilleures performances à basses températures extérieures. Le choix influe sur les hypothèses standard de rendement de l'installation.",
          azimuth:
            "L'azimut est l'orientation des capteurs par rapport aux points cardinaux en degrés, où 0 signifie généralement plein sud. Il décrit la direction vers laquelle les capteurs sont orientés et influe fortement sur la quantité d'énergie solaire captée.",
          tilt: "L'inclinaison est l'angle des capteurs par rapport à l'horizontale en degrés, où 0 est plat et 90 vertical. Avec l'azimut, elle détermine la quantité de rayonnement solaire que reçoivent les capteurs sur l'année.",
          adjustmentFactor:
            "Le facteur d'ajustement augmente ou diminue le rendement solaire calculé pour tenir compte des conditions locales telles que l'ombrage ou l'encrassement. Indiquez une valeur uniquement si vous souhaitez corriger le calcul standard ; sinon laissez le champ vide.",
          performance:
            "La performance indique le niveau de rendement nominal ou de capacité de l'installation solaire thermique, c'est-à-dire l'efficacité avec laquelle les capteurs convertissent le rayonnement solaire en chaleur utile. Sélectionnez ou indiquez le niveau s'il est connu d'après la documentation, sinon des valeurs standard sont utilisées.",
          pipeLength:
            "La longueur de tuyauterie est la longueur totale des tuyaux entre les capteurs et le réservoir de stockage, en mètres. Des tuyaux plus longs perdent plus de chaleur. Indiquez-la avec le type d'isolation des tuyaux si vous souhaitez calculer les pertes de tuyauterie plus en détail.",
          pipeInsulationType:
            "Le type d'isolation des tuyaux décrit dans quelle mesure les tuyaux entre les capteurs et le réservoir sont isolés, ce qui fixe la déperdition de chaleur standard par mètre de tuyau. Sélectionnez-le si connu, sinon une valeur standard est utilisée.",
          pipeUValue:
            "La valeur U des tuyaux indique la quantité de chaleur que les tuyaux du circuit de capteurs perdent par mètre et par degré de différence de température (W/mK). Une valeur plus faible signifie une meilleure isolation. Indiquez-la si elle est connue, sinon elle est déduite du type d'isolation des tuyaux sélectionné.",
          collectorArea:
            "La surface de captage est la surface active totale des capteurs solaires, en m². C'est une donnée d'entrée essentielle pour le calcul de production, car une plus grande surface de capteurs fournit plus d'énergie solaire.",
          tankSpiralPlacementFactor:
            "Le facteur de placement du serpentin du réservoir décrit où se trouve le serpentin solaire dans le réservoir de stockage, ce qui influe sur l'efficacité du transfert de la chaleur solaire vers l'eau. Indiquez une valeur si vous disposez de données détaillées pour le système, sinon une valeur standard est utilisée.",
          temperatureColdWater:
            "La température de l'eau froide est la température de l'eau fournie au système avant d'être chauffée par les capteurs, en °C. Une température d'eau froide plus basse donne un rendement solaire plus élevé. Indiquez une valeur si vous souhaitez remplacer la valeur standard.",
          percentageOfCollectorLoopOutside:
            "Il s'agit de la part du circuit de capteurs (tuyaux et composants) située à l'extérieur, en pourcentage. Les tuyaux situés à l'extérieur perdent plus de chaleur. Indiquez une valeur si cela est pertinent pour le calcul des pertes.",
          collectorSpecs:
            'Ces valeurs constituent la courbe de rendement du capteur, issue de la fiche technique du produit ou du certificat Solar Keymark. η₀ est le rendement optique sans différence de température, tandis que les coefficients de déperdition a₁ et a₂ décrivent la vitesse à laquelle le rendement baisse lorsque le capteur devient plus chaud que son environnement. Indiquez les valeurs si une documentation existe, sinon des valeurs standard sont utilisées.',
          snowCoverageMonths:
            "Sélectionnez les mois pendant lesquels les capteurs solaires sont normalement couverts de neige. Pendant ces mois, les capteurs produisent peu ou pas d'énergie, ce qui donne un calcul annuel plus réaliste où la neige influe sur la production.",
          insulationFactorForCollectionLoop:
            "Le facteur d'isolation du circuit de captage décrit dans quelle mesure les tuyaux et composants du circuit solaire sont isolés dans l'ensemble. Sélectionnez un niveau si vous souhaitez un calcul plus précis de la déperdition de chaleur du circuit, sinon une valeur standard est utilisée.",
        },
        otherSource: {
          fuelType:
            "Le type de combustible est le vecteur énergétique utilisé par cette source, par exemple fioul, gaz, biocombustible, réseau de chaleur ou électricité. Le choix détermine le facteur d'émission standard et la manière dont l'énergie est comptabilisée.",
          maxCapacity:
            "La capacité maximale est la puissance la plus élevée que cette source d'énergie peut fournir, en kW. C'est la valeur principale pour évaluer si la source couvre le besoin de puissance.",
          efficiency:
            "Le rendement décrit la part de l'énergie fournie qui devient de la chaleur ou du froid utile, après les pertes dans la source. Indiquez une valeur si elle est connue, sinon une hypothèse standard est utilisée.",
          co2eEmissionFactor:
            "Le facteur d'émission de CO₂e indique la quantité d'émissions de gaz à effet de serre associée à l'énergie utilisée par cette source, exprimée en grammes par kWh. Indiquez une valeur spécifique si vous souhaitez un calcul d'émissions précis. Il n'affecte que le bilan des émissions, pas le besoin énergétique.",
          energyPrice:
            "Le prix de l'énergie est le coût par kWh d'énergie provenant de cette source. Indiquez un prix spécifique si vous souhaitez des calculs de coûts avec des prix réels, sinon le champ peut rester vide. Il n'affecte que les chiffres de coût, pas l'énergie ni les émissions.",
        },
        accumulationTank: {
          purpose:
            "Un réservoir d'accumulation stocke de la chaleur ou du froid afin que la production et la consommation puissent être décalées dans le temps. Sélectionnez l'objectif, par exemple stockage de chaleur, stockage de froid ou eau chaude, décrivant la fonction du réservoir dans le système.",
          volume:
            "Le volume est la capacité de stockage du réservoir en litres et constitue le paramètre principal de la quantité de chaleur ou de froid que le réservoir peut stocker. Indiquez-le si un réservoir d'accumulation existe.",
          insulation:
            "Le niveau d'isolation décrit dans quelle mesure le réservoir est isolé et détermine la quantité de chaleur perdue vers l'environnement. Sélectionnez le niveau ou le type si connu. Utilisé pour estimer ou remplacer la déperdition de chaleur du réservoir.",
          heatLoss:
            "La déperdition de chaleur (W/K) indique la puissance que le réservoir perd vers l'environnement par degré de différence de température. Indiquez une valeur documentée si vous en disposez. Peut normalement rester vide si le volume et l'isolation standard suffisent.",
          setpoint:
            'La température de consigne est la température de stockage souhaitée dans le réservoir, en °C. Elle détermine à quel point le fluide est maintenu chaud ou froid et influe à la fois sur les pertes et la capacité.',
          maxTemp:
            'La température maximale est la température la plus élevée que le réservoir est autorisé à atteindre, en °C. Indiquez-la si cela est connu ou pertinent pour la régulation.',
          minTemp:
            'La température minimale est la température la plus basse à laquelle le réservoir est autorisé à descendre, en °C. Indiquez-la si cela est connu ou pertinent pour la régulation.',
          minTempDhw:
            "La température minimale est la température la plus basse à laquelle le réservoir est autorisé à descendre, en °C. Pour les ballons d'eau chaude sanitaire, maintenez-la à au moins 70 °C pour éviter le développement des légionelles.",
        },
      },
      excessEnergy: {
        medium:
          "Le médium est ce dans quoi l'énergie excédentaire circule : l'air, par exemple un conduit d'extraction, ou un liquide, par exemple une conduite d'eaux usées. Le choix détermine quels champs sont affichés et comment l'énergie disponible est calculée.",
        name: "Donnez à la source d'énergie excédentaire un nom clair. Le nom sert à identifier les sources potentielles de récupération, par exemple l'air extrait d'une cuisine ou la chaleur fatale d'un procédé.",
        ductShape:
          "Sélectionnez le médium et la forme du conduit pour la source. La forme du conduit, par exemple ronde ou rectangulaire, est utilisée avec les dimensions pour calculer la section et donc le flux d'énergie disponible lorsque l'énergie excédentaire est prélevée dans l'air.",
        ductWidthDiameter:
          "Indiquez la largeur ou le diamètre du conduit en mm s'il est connu. Utilisé avec la forme du conduit, et éventuellement la hauteur, la vitesse d'air ou le débit volumique, pour calculer la quantité d'air qui circule dans le conduit.",
        height:
          "Indiquez la hauteur du conduit en mm si la forme du conduit l'exige, par exemple pour un conduit rectangulaire. Avec la largeur, elle donne la section du conduit.",
        airspeed:
          "La vitesse d'air est la vitesse à laquelle l'air circule dans le conduit, en m/s. Indiquez-la si le débit volumique n'est pas connu directement ; le débit d'air est alors calculé à partir de la vitesse et de la section du conduit.",
        exhaustTempAir:
          "La température d'air extrait est la température du flux d'air dont l'énergie excédentaire est tirée, en °C. La température est déterminante pour évaluer la quantité d'énergie récupérable ; une température plus élevée fournit plus de chaleur disponible.",
        exhaustTempLiquid:
          "Indiquez la température du flux de liquide dont l'énergie excédentaire est tirée, en °C. La température est déterminante pour évaluer la quantité d'énergie récupérable à partir du liquide.",
        volumeFlowAir:
          "Le débit volumique est la quantité d'air qui passe par heure, en m³/h. Avec la température, il détermine la quantité d'énergie disponible pour la récupération. Indiquez-le s'il est connu, sinon il peut être calculé à partir de la géométrie du conduit et de la vitesse d'air.",
        volumeFlowLiquid:
          "Le débit volumique est la quantité de liquide qui passe par heure, en L/h. Avec la température, il détermine la quantité d'énergie disponible pour la récupération. Indiquez-le s'il est connu.",
      },
      solarPv: {
        panelAngle:
          "L'inclinaison des panneaux solaires mesurée par rapport à l'horizontale, en degrés. Un panneau posé à plat sur le toit est à 0° et un panneau dressé verticalement à 90°. L'inclinaison détermine la manière dont la lumière du soleil frappe les panneaux au fil de l'année et influence donc fortement la production annuelle estimée.",
        name: "Un nom clair et reconnaissable pour cette installation photovoltaïque. Il sert à identifier le champ de panneaux dans les listes, les résultats et les rapports, ce qui est utile lorsqu'un bâtiment comporte plusieurs installations photovoltaïques distinctes.",
        panelArea:
          "La surface active des panneaux solaires, en mètres carrés. Indiquez soit la surface d'un seul panneau, soit la surface combinée de l'ensemble de l'installation, selon la manière dont l'installation est enregistrée, et faites correspondre Quantité à ce choix. Avec le rendement des panneaux, la surface est l'une des données centrales qui déterminent la quantité d'électricité que le système peut produire.",
        quantity:
          "Le nombre de panneaux solaires de l'installation, s'il est connu. Il est combiné à la surface des panneaux et au rendement pour estimer la capacité installée et doit correspondre à la façon dont la surface a été saisie : utilisez le nombre de panneaux lorsque la surface des panneaux est par panneau, et 1 lorsqu'elle correspond à la surface totale de l'installation.",
        yearInstalled:
          "L'année de mise en service de l'installation photovoltaïque. Elle est enregistrée pour l'inspection, mais le calcul ne l'utilise pas : le vieillissement des panneaux est toujours calculé sur une durée de vie fixe de 30 ans, avec la perte de dégradation annuelle.",
        soilingLocation:
          "Le type de site qui détermine la vitesse à laquelle la poussière, le pollen et la pollution s'accumulent sur les panneaux. Le choix d'un emplacement, par exemple urbain, rural ou une autre exposition, charge un profil mensuel d'encrassement standard pour cet environnement, que vous pouvez ensuite ajuster mois par mois ci-dessous.",
        monthlySoiling:
          "L'encrassement est la perte de production causée par la saleté, la poussière, la neige et la pollution sur la surface des panneaux, et il varie au cours de l'année. La sélection d'un emplacement remplit un profil standard simplifié ; saisissez ici votre propre valeur pour chaque mois si vous souhaitez remplacer ce profil par des chiffres propres au site.",
        cellType:
          "La technologie photovoltaïque des panneaux, par exemple silicium monocristallin ou polycristallin. Le type de cellule détermine l'efficacité avec laquelle les panneaux convertissent la lumière du soleil en électricité ; le choisir définit donc un rendement nominal par défaut représentatif que vous pouvez encore ajuster.",
        nominalEfficiency:
          "La part de l'énergie solaire incidente que les panneaux convertissent en électricité dans des conditions d'essai normalisées, exprimée en décimale (par exemple 0,20 pour 20 %). Saisissez la valeur documentée de la fiche technique si elle est connue ; sinon, la valeur par défaut du type de cellule choisi est utilisée.",
        panelAzimuth:
          "L'orientation des panneaux par rapport aux points cardinaux, en degrés de 0 à 360 (le sud se situe autour de 180° dans l'hémisphère nord). L'azimut, avec l'inclinaison, détermine la part de la course du soleil que les panneaux captent au cours de la journée et de l'année, et influence donc directement la production estimée.",
        shadingFactor:
          "La part du rayonnement solaire que les panneaux perdent à cause de l'ombrage (bâtiments voisins, relief, végétation), de 0 à 1. 0 signifie aucun ombrage et 1 un ombrage total ; la valeur par défaut 0,05 correspond donc à une perte de 5 %. La valeur est enregistrée, mais le calcul ne l'utilise pas encore.",
        mountingType:
          "La manière dont les panneaux sont montés, par exemple intégrés en toiture ou autoportants avec une lame d'air. Le type de montage détermine la qualité du refroidissement des panneaux par l'air environnant, ce qui alimente le modèle plus détaillé de température et de pertes des panneaux. Sélectionnez-le si vous souhaitez ce niveau de détail.",
        windExposure:
          "Le degré d'exposition de l'installation au vent. Le vent refroidit les panneaux et abaisse leur température de fonctionnement, ce qui améliore le rendement ; cette donnée est donc utilisée avec le type de montage dans le modèle plus détaillé de température des panneaux. Sélectionnez-la si elle est connue.",
        heatLossFactor:
          "La facilité avec laquelle les panneaux cèdent de la chaleur à leur environnement, en W/m²K. Elle est normalement déduite du type de montage et de l'exposition au vent, mais vous pouvez saisir une valeur ici pour remplacer ces hypothèses standard et contrôler la manière dont la température des panneaux est modélisée.",
        inverterEfficiency:
          "La part du courant continu issu des panneaux que l'onduleur restitue en courant alternatif utilisable, en décimale (par exemple 0,945). Elle traduit la perte de conversion de l'onduleur ; saisissez la valeur documentée de la fiche technique si elle est connue.",
        degradationLoss:
          "La baisse progressive et permanente de la production des panneaux à mesure que les modules vieillissent, en décimale (par exemple 0,005 pour 0,5 % par an). Saisissez-la si vous souhaitez modéliser plus précisément la baisse de performance sur la durée de vie de l'installation.",
        inverterLoss:
          "Pertes supplémentaires liées à l'onduleur et à son fonctionnement, en décimale. Utilisez ce champ lorsque vous souhaitez enregistrer les pertes liées à l'onduleur séparément du rendement de l'onduleur plutôt que de les regrouper en une seule valeur.",
        transmissionProduct:
          "Un facteur combiné (0 à 1) pour les pertes optiques lorsque la lumière traverse le verre de protection du panneau et atteint les cellules, comme la réflexion et l'absorption. Saisissez-le en décimale lorsque la méthode de calcul choisie utilise ce terme.",
        temperatureCoefficient:
          "L'ampleur de la variation de la production des panneaux avec la température, en %/°C. Elle est normalement négative car la production diminue lorsque les panneaux chauffent au-dessus de leur température d'essai nominale. Saisissez la valeur documentée de la fiche technique si elle existe pour ces panneaux.",
        incidentAngleModifier:
          "Un facteur (0 à 1) qui tient compte des pertes de réflexion supplémentaires lorsque la lumière du soleil frappe le panneau de biais plutôt que de face. Saisissez-le en décimale si vous souhaitez utiliser le modèle solaire plus détaillé qui prend en compte ces effets d'angle d'incidence.",
      },
      battery: {
        name: "Un nom clair et reconnaissable pour cette batterie. Il sert à identifier la batterie dans les listes, les résultats et les rapports, ce qui est utile lorsqu'un bâtiment possède plusieurs batteries.",
        maxCapacity:
          "La quantité totale d'énergie que la batterie peut stocker, en kWh. Il s'agit de la capacité nominale du système de batterie ; elle fixe la limite de la quantité de surplus solaire pouvant être stockée pour une utilisation ultérieure.",
        maxChargePower:
          "La puissance maximale à laquelle la batterie peut se charger, en kW. Elle limite la vitesse à laquelle la batterie peut absorber le surplus solaire ou l'électricité du réseau.",
        maxDischargePower:
          'La puissance maximale que la batterie peut restituer au bâtiment, en kW. Elle limite la part de la charge du bâtiment que la batterie peut couvrir à chaque instant.',
        chargeEfficiency:
          "La part de l'énergie envoyée dans la batterie qui est réellement stockée, entre 0 et 1. Laissez 0 pour utiliser la valeur par défaut typique des batteries lithium-ion.",
        dischargeEfficiency:
          "La part de l'énergie stockée qui est réellement restituée lorsque la batterie se décharge, entre 0 et 1. Laissez 0 pour utiliser la valeur par défaut typique des batteries lithium-ion.",
        minStateOfCharge:
          'Le niveau le plus bas auquel la batterie peut se décharger, en part de la capacité totale entre 0 et 1. Garder une réserve protège la durée de vie de la batterie. Laissez 0 pour utiliser la valeur par défaut.',
        maxStateOfCharge:
          'Le niveau le plus haut auquel la batterie peut se charger, en part de la capacité totale entre 0 et 1. Charger légèrement en dessous du maximum protège la durée de vie de la batterie. Laissez 0 pour utiliser la valeur par défaut.',
        peakShavingThreshold:
          "L'importation réseau sous laquelle la batterie essaie de maintenir le bâtiment, en kW. Lorsque le bâtiment tirerait davantage du réseau, la batterie se décharge pour couvrir la différence. Laissez 0 pour désactiver l'écrêtage des pointes ; la batterie ne fait alors que stocker le surplus solaire et couvrir les déficits.",
        preChargeStateOfCharge:
          "Le niveau auquel la batterie se précharge depuis le réseau pendant les heures calmes, en part de la capacité totale entre 0 et 1, afin d'être prête pour la prochaine pointe. Utilisé uniquement lorsqu'un seuil d'écrêtage est défini. Laissez 0 pour désactiver la précharge.",
      },
    },
  },

  // Page titles
  title: 'Inspections de bâtiments',
  sidebarTitle: 'Inspection',
  new: 'Nouvelle inspection',
  edit: "Modifier l'inspection",

  // List page
  fetchError: 'Échec du chargement des inspections.',
  noInspections: 'Aucune inspection trouvée.',
  createNew: 'Nouvelle inspection',
  confirmDeleteTitle: 'Supprimer les inspections',
  confirmDeleteDescription:
    'Êtes-vous sûr de vouloir supprimer cette inspection ?',
  duplicate: 'Dupliquer',
  duplicating: "Duplication de l'inspection...",
  duplicateSuccess: 'Inspection dupliquée',
  duplicateError: "Échec de la duplication de l'inspection",
  renameInspection: "Renommer l'inspection",

  // Common
  common: {
    // generic
    custom: 'Personnalisé',
    standard: 'Standard',
    other: 'Autre',
    text: 'Texte',
    from: 'De',
    to: 'À',
    hide: 'Masquer',
    show: 'Afficher',
    horizontal: 'Horizontale',
    vertical: 'Verticale',
    addImage: 'Ajouter une image',
    confirmDeleteImage: 'Voulez-vous vraiment supprimer cette image ?',
    generating: 'Génération...',
    indoorClimate: 'Climat intérieur',
    score: 'Score',
    energyData: 'Données énergétiques',
    air: 'Air',
    liquid: 'Liquide',
    round: 'Rond',
    square: 'Carré/rectangulaire',

    // field labels
    quantity: 'Quantité',
    location: 'Emplacement',
    priority: 'Priorité',
    yearInstalled: "Année d'installation",
    medium: 'Fluide',

    // section / navigation labels
    inspection: 'Inspection',
    info: 'Informations',
    purpose: 'Usage',
    module: 'Module',
    control: 'Contrôle & Régulation',
    equipment: 'Équipement',
    hvacSystems: 'Systèmes CVC',
    thermalZones: 'Zones thermiques',
    zones: 'Zones',
    heatingCooling: 'Chauffage & refroidissement',
    heatingAndCooling: 'Chauffage et refroidissement',
    heatingOnly: 'Chauffage uniquement',
    domesticHotWater: 'Eau chaude sanitaire',
    centralEnergy: 'Énergie centrale',
    excessEnergy: 'Énergie excédentaire',
    solarPv: 'Photovoltaïque',
    solarThermal: 'Solaire thermique',
    solarCells: 'Photovoltaïque',
    attachments: 'Pièces jointes',
    annualSimulation: 'Simulation annuelle',
    energyLabel: 'Étiquette énergétique',
    actions: 'Actions',
    lighting: 'Éclairage',
    report: 'Rapport',
    hvac: 'CVC',
    windows: 'Fenêtres',
    doors: 'Portes',
    gates: 'Portails',
    walls: 'Murs',
    exteriorWalls: 'Murs extérieurs',
    floor: 'Plancher sur le sol',
    roof: 'Toiture',
    basement: 'Construction du sous-sol',
    groundConditions: 'Conditions du sol',
    airLeakage: "Fuite d'air",
    thermalMass: 'Masse thermique',
    internalLoads: 'Charges internes',
    productionEquipment: 'Équipement de production',
    ground: 'Sol',
    zone: 'Zone',
    wall: 'Mur',
    window: 'Fenêtre',
    door: 'Porte',
    gate: 'Portail',

    // climate
    climate: 'Climat',
    climatized: 'Climatisé',
    partlyClimatized: 'Partiellement climatisé',
    unclimatized: 'Non climatisé',
    floorHeight: "Hauteur d'étage (m)",

    // units and physical quantities
    area: 'Surface (m²)',
    areaShort: 'Surface',
    volume: 'Volume (L)',
    volumeShort: 'Volume',
    length: 'Longueur (m)',
    power: 'Puissance (kW)',
    powerShort: 'Puissance',
    uValue: 'Valeur U (W/m²K)',
    uValueShort: 'Valeur U',
    coverageArea: 'Zone de couverture (m²)',
    coverageAreaShort: 'Zone de couverture',
    coverageVolume: 'Volume de couverture',
    heatingEffect: 'Puissance de chauffage (kW)',
    coolingEffect: 'Puissance de refroidissement (kW)',
    effect: 'Puissance (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'COP saisonnier',
    seasonalEER: 'EER saisonnier',
    efficiency: 'Rendement',
    systemEfficiency: 'Rendement du système (%)',
    co2eEmissionFactor: "Facteur d'émission CO₂e (g/kWh)",
    temperatureSupply: 'Température de soufflage (°C)',
    temperatureReturn: 'Température de retour (°C)',
    avgTemp: 'Temp moy',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: "Débit d'air",
    heatRecovery: 'Récupération de chaleur',
    panelArea: 'Surface du panneau',
    cellType: 'Type de cellule',
    azimuth: 'Azimut',
    value: 'Valeur',
    unit: 'Unité',

    // system / fuel
    systemType: 'Type de système',
    systemTypeShort: 'Type de système',
    energySource: "Source d'énergie",
    energySourceShort: "Source d'énergie",
    specificFuelType: 'Type de combustible',
    selectSpecificFuelType: 'Sélectionner le combustible...',
    inverterControlled: 'Contrôlé par onduleur',
    nominalLoad: 'Charge nominale',
    minimumLoad: 'Charge minimale',
    degradeCoeff: 'Coeff. de dégradation',
    heatPump: 'Pompe à chaleur',
    electric: 'Électrique',
    oil: 'Fioul',
    gas: 'Gaz',
    rock: 'Roche',
    coolingOnly: 'Refroidissement uniquement',

    // performance / magnitude grades
    high: 'Élevé',
    low: 'Faible',
    normal: 'Normal',

    // dimensions
    width: 'Largeur (m)',
    height: 'Hauteur (m)',
    depth: 'Profondeur (m)',

    // zone editor
    userDefined: "Défini par l'utilisateur",
    calculator: 'Calculateur',
    compass: {
      N: 'N',
      NE: 'NE',
      E: 'E',
      SE: 'SE',
      S: 'S',
      SW: 'SO',
      W: 'O',
      NW: 'NO',
    },
    directions: {
      n: 'Nord (0°)',
      ne: 'Nord-est (45°)',
      e: 'Est (90°)',
      se: 'Sud-est (135°)',
      s: 'Sud (180°)',
      sw: 'Sud-ouest (225°)',
      w: 'Ouest (270°)',
      nw: 'Nord-ouest (315°)',
    },
    structuralNodes: 'Nœuds structurels',
    structuralNode: 'Nœud structurel',
    addStructuralNode: 'Ajouter un nœud structurel',
    copyStructuralNode: 'Copier le nœud structurel',
    confirmDeleteStructuralNode: 'Supprimer ce nœud structurel ?',
    boundary: 'Condition limite',
    boundaryInteriorAir: 'Air intérieur',
    boundaryExterior: 'Extérieur',
    boundaryAdjacentZone: 'Zone adjacente',
    boundaryAdiabatic: 'Adiabatique',
    node: 'Nœud',
    addNode: 'Ajouter un nœud',
    copyNode: 'Copier le nœud',
    confirmDeleteNode: 'Supprimer ce nœud ?',
    surfaceType: 'Type de surface',
    surfaceCeiling: 'Plafond',
    surfaceArea: 'Surface (m\u00B2)',
    heatTransferCoeff: 'Coeff. de transfert thermique (W/m\u00B2K)',
    totalMass: 'Masse totale (kg/m\u00B3)',
    specificHeatCapacity: 'Capacité thermique massique (J/kgK)',

    // insulation grades
    insulated: 'Isolé',
    uninsulated: 'Non isolé',
    poorlyInsulated: 'Mal isolé',
    normallyInsulated: 'Normalement isolé',
    wellInsulated: 'Bien isolé',
    veryWellInsulated: 'Très bien isolé',
    selectInsulation: "Sélectionner l'isolation...",
    selectPerformance: 'Sélectionner le rendement...',
    selectFuelType: 'Sélectionner le type de combustible...',

    // UI layout
    basicSettings: 'Paramètres de base',
    additionalInfo: 'Informations complémentaires',
    showAdvanced: 'Afficher avancé',
    hideAdvanced: 'Masquer avancé',
    advanced: 'Avancé',

    // actions
    settingUp: 'Configuration...',
    co2PerKwh: 'CO₂ par kWh [g]',
    gridFee: 'Frais de réseau [NOK/kWh]',
    enovaSupport: 'Aide Enova [%]',
    descriptionPlaceholder:
      "Décrivez l'action en détail : ce qui est modifié, pourquoi et le résultat attendu. Incluez un calcul de la réduction estimée de la consommation d'énergie si la mesure est mise en œuvre, ainsi qu'une évaluation des coûts et des conséquences concernant l'humidité et le climat intérieur liés à la mesure.",
    electricityZone: "Zone d'électricité",
    selectZone: 'Sélectionner une zone...',
    runSimulation: 'Lancer la simulation',
    runningSimulation: 'Simulation en cours...',
    simulationDescription: 'Lance une simulation horaire du bilan énergétique',
    baselineProgress: 'Simulation de référence en cours... (1/2)',
    actionProgress: "Simulation d'action en cours... (2/2)",
    baselineStarted: 'Simulation de référence lancée...',
    simulationStarted: "Simulation d'action lancée...",
    noAnnualSimulation:
      "Lancez d'abord une simulation annuelle pour activer la comparaison des actions.",
    simulationResults: 'Résultats de simulation',
    lastSimulated: 'Dernière simulation',
    nettEnergyDemand: 'Besoin énergétique net',
    energyCategory: "Catégorie d'énergie",
    baselineKwh: 'Référence (kWh)',
    actionKwh: 'Action (kWh)',
    savingsKwh: 'Économies (kWh)',
    baselineKwhM2: 'Référence (kWh/m²)',
    actionKwhM2: 'Action (kWh/m²)',
    savingsPercent: 'Économies (%)',
    baseline: 'Référence',
    afterAction: "Après l'action",
    solarProduction: 'Production solaire',
    savings: 'Économies',
    costSavings: 'Coût et économies',
    annualEnergySavings: "Économies d'énergie annuelles",
    kwhYear: 'kWh/an',
    energySavingsTooltip:
      'Réduction de la demande énergétique totale grâce aux améliorations',
    reduction: 'réduction',
    increase: 'augmentation',
    annualCostSavings: 'Économies de coûts annuelles',
    nokYear: 'NOK/an',
    costSavingsTooltip:
      "Économies totales grâce à la réduction de la consommation d'énergie et aux revenus de la production solaire exportée",
    netCo2Reduction: 'Réduction nette de CO₂',
    kgCo2Year: 'kg CO₂/an',
    co2Tooltip: 'Utilisant {value} g CO₂/kWh',
    tonnes: 'tonnes',
    paybackPeriod: 'Période de retour',
    paybackTooltip: "Temps pour récupérer l'investissement initial",
    years: 'ans',
    investmentLabel: 'Investissement : {value} NOK',
    noInvestmentCost: "Aucun coût d'investissement spécifié",
    beforeExisting: 'Avant - Système existant',
    afterNew: 'Après - Nouveau système',
    investment: 'Investissement',
    installationType: "Type d'installation",
    simple: 'Simple',
    complex: 'Complexe',
    deliveredEnergy: 'Énergie livrée',
    roiTitle: 'Retour sur investissement',
    roiCumulativeSavings: 'Économies cumulées',
    roiNetValue: 'Valeur nette (après investissement)',
    roiYears: 'Années',
    roiBreakEven:
      'Le seuil de rentabilité est atteint lorsque la valeur nette dépasse zéro (année {value})',

    // misc
    presenceControl: 'Détection de présence',
    distributionLosses: "Pertes de distribution et d'accumulation",
    installationCost: "Coût d'installation [NOK]",
    installationCostShort: "Coût d'installation",
    noZones:
      "Aucune zone thermique trouvée. Ajoutez des zones thermiques dans la section Zones thermiques d'abord.",

    // shared energy source labels
    energySources: {
      electricity: 'Électricité',
      heatpumpAirToAir: 'Pompe à chaleur air-air',
      fossilOil: 'Fioul fossile',
      fossilGas: 'Gaz fossile',
      fossilSolidFuel: 'Combustible solide fossile',
      bioOil: 'Huile bio',
      bioGas: 'Biogaz',
      bioSolidFuel: 'Combustible solide bio',
      districtHeating: 'Chauffage urbain',
      districtCooling: 'Refroidissement urbain',
      otherSources: 'Autres sources',
    },

    // shared schedule block
    schedule: {
      operationalSchedule: 'Planning opérationnel',
      addSchedule: 'Ajouter un horaire',
      clickToToggle: 'Cliquez sur les heures pour activer/désactiver',
      avgTemp: 'Temp moy',
      days: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
      months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      hours: 'Heures',
      weekly: 'Hebdomadaire',
      annual: 'Annuel',
      on: 'ON',
      off: 'OFF',
      hoursPerDayUnit: 'h/jour',
      hoursPerWeekUnit: 'h/semaine',
      hoursPerYearUnit: 'h/an',
      setpointPerHour: 'Température de consigne par heure',
      setpointInfoTooltip:
        'Utilisez ON/OFF pour contrôler les heures de fonctionnement. Les valeurs de consigne des heures ON sont utilisées dans les calculs. Les heures OFF sont hors fonctionnement.',
      copyToWeekdays: 'Copier vers jours ouvrables',
      copyToWeekends: 'Copier vers week-end',
      resetToStandards: 'Réinitialiser selon',
      confirmDeleteSchedule: 'Supprimer cet horaire ?',
      fromMonth: 'De',
      toMonth: 'À',
    },
  },

  // List page labels
  lists: {
    quantity: 'Quantité',
    totalArea: 'Total (m²)',
    thermalZones: {
      duplicateZone: 'Dupliquer la zone',
      copySuffix: 'copie',
      duplicateSuccess: 'Zone dupliquée avec succès',
      duplicateError: 'Échec de la duplication de la zone',
    },
    exteriorWalls: {
      addFirst: 'Cliquez pour ajouter votre premier mur extérieur',
      addWall: 'Ajouter un mur',
      duplicateWall: 'Dupliquer le mur',
    },
    windows: {
      addFirst: 'Cliquez pour ajouter votre première fenêtre',
      addWindow: 'Ajouter fenêtre',
    },
    doors: {
      addFirst: 'Cliquez pour ajouter votre première porte',
      addDoor: 'Ajouter porte',
    },
    gates: {
      addFirst: 'Cliquez pour ajouter votre premier portail',
      addGate: 'Ajouter portail',
    },
    productionEquipment: {
      addFirst: 'Cliquez pour ajouter votre premier équipement de production',
      addEquipment: 'Ajouter équipement de production',
    },
    hvac: {
      addFirst: 'Cliquez pour ajouter votre première unité CVC',
      addHvac: 'Ajouter CVC',
    },
    heatingCooling: {
      addFirstHeating:
        'Cliquez pour ajouter un système de chauffage ou de refroidissement',
      addHeating: 'Ajouter un système',
    },
    domesticHotWater: {
      add: 'Ajouter eau chaude sanitaire',
      addFirst: 'Cliquez pour ajouter eau chaude sanitaire',
    },
    centralEnergy: {
      add: "Ajouter un module d'énergie centrale",
      addFirst: "Cliquez pour ajouter un module d'énergie centrale",
    },
    excessEnergy: {
      add: "Ajouter un module d'énergie excédentaire",
      addFirst: "Cliquez pour ajouter un module d'énergie excédentaire",
    },
    solarPv: {
      add: 'Ajouter un module photovoltaïque',
      addFirst: 'Cliquez pour ajouter un module photovoltaïque',
    },
    batteries: {
      add: 'Ajouter une batterie',
      addFirst: 'Cliquez pour ajouter une batterie',
    },
    attachments: {
      noInspectionFound: 'Aucune inspection trouvée',
    },
  },

  // Edit page - Form fields
  inspector: 'Inspecteur',
  selectBuilding: 'Sélectionner un bâtiment',
  selectedBuilding: 'Bâtiment',
  selectBuildingPlaceholder: 'Sélectionner un bâtiment...',
  notes: 'Notes',

  // Edit page - Map panel
  advancedComingSoon: 'En développement',
  mapPlaceholder: 'Carte Sastech',

  // Status options
  statusDraft: 'Brouillon',
  statusInReview: 'En révision',
  statusCompleted: 'Terminé',

  // Validation & feedback
  buildingRequired: 'Veuillez sélectionner un bâtiment',
  gpsRequired: 'Le bâtiment sélectionné doit avoir une position GPS',
  createSuccess: 'Inspection créée avec succès',
  updateSuccess: 'Inspection mise à jour avec succès',
  saved: 'enregistré',
  saveError: "Échec de l'enregistrement de l'inspection",
  loadError: "Échec du chargement des données d'inspection",

  // Delete dialog
  deleteTitle: "Supprimer l'inspection",
  deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette inspection?',
  deleteSuccess: 'Inspection supprimée avec succès',
  deleteError: "Échec de la suppression de l'inspection",

  // Zone edit
  zoneName: 'Nom de la zone',
  zoneCategory: 'Catégorie de zone',
  buildingSubcategory: 'Sous-catégorie de bâtiment',
  zoneSaved: 'Zone enregistrée',
  standardElementsUpdated: 'Mise à jour de {count} éléments vers {tek}',
  braRequired: 'BRA supérieur à 0 est requis',
  basementAreaRequired:
    'Une surface de plancher de sous-sol supérieure à 0 est requise',
  categoryRequired: 'Veuillez sélectionner une catégorie de bâtiment',
  yearRequired: "Veuillez indiquer l'année de construction",
  floorsRequired: "Veuillez indiquer le nombre d'étages",
  zoneCategoryRequired: 'Veuillez sélectionner une catégorie de zone',
  subcategoryRequired: 'Veuillez sélectionner une sous-catégorie de bâtiment',
  zoneClimateRequired: 'Veuillez sélectionner un climat de zone',
  floorHeightRequired: "Une hauteur d'étage supérieure à 0 est requise",
  airLeakageN50Required:
    "Un taux de fuite d'air (n50) supérieur à 0 est requis",
  thermalBridgePsiRequired:
    'Une valeur de pont thermique normalisée est requise',
  panelAreaRequired: 'Une surface de panneau supérieure à 0 est requise',
  yearInstalledRequired: "L'année d'installation est requise",
  soilingLocationRequired: 'Veuillez sélectionner un emplacement de salissure',
  cellTypeRequired: 'Veuillez sélectionner un type de cellule',
  deleteZone: 'Supprimer la zone',
  deleteZoneWarning: 'Cette action ne peut pas être annulée',
  confirmDeleteZone: 'Supprimer cette zone?',
  indoorTemp: 'Température initiale (°C)',
  zoneClimate: 'Climat de zone',
  thermalBridgeCoeff: 'Structure porteuse (pont thermique)',
  thermalBridgePsiValue: 'Coefficient de pont thermique normalisé ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Personnalisé',
    wood: 'Bâtiment avec structure porteuse en bois',
    concrete_10cm:
      'Bâtiment avec structure porteuse en béton, maçonnerie ou acier et 10 cm de rupteur de pont thermique en façades',
    concrete_5cm:
      'Bâtiment avec structure porteuse en béton, maçonnerie ou acier et 5 cm de rupteur de pont thermique en façades',
  },
  addZone: 'Ajouter une zone',
  addFirstZone: 'Cliquez pour ajouter votre première zone',
  image: 'Image',
  upload: 'Télécharger',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Supprimer le système',
    confirmDeleteModule: 'Supprimer ce système?',
    deleteHeating: 'Supprimer le module de chauffage',
    deleteCooling: 'Supprimer le module de refroidissement',
    confirmDeleteHeating: 'Supprimer ce module de chauffage?',
    confirmDeleteCooling: 'Supprimer ce module de refroidissement?',
    systemType: 'Type',
    priorityHelp: '1 = priorité la plus élevée (couvre la demande en premier)',
    maxTemperatureSupplied: 'Température maximale fournie (°C)',
    systemTypeRequired: 'Veuillez sélectionner un type de système',
    energySourceRequired: "Veuillez sélectionner une source d'énergie",
    heatingEffectRequired:
      'Une puissance de chauffage supérieure à 0 est requise',
    coolingEffectRequired:
      'Une puissance de refroidissement supérieure à 0 est requise',
    systemEfficiencyRequired:
      'Un rendement de système supérieur à 0 est requis',
    copRequired: 'Un COP supérieur à 0 est requis',
    eerRequired: 'Un EER supérieur à 0 est requis',
  },

  domesticHotWater: {
    deleteDhw: 'Supprimer eau chaude sanitaire',
    confirmDelete: "Supprimer ce module d'eau chaude sanitaire ?",
    heaterType: 'Type de chauffage',
    volume: 'Volume (L)',
    setpointTemperature: 'Température de consigne (°C)',
    heatingElementPower: "Puissance de l'élément chauffant (kW)",
    heaterTypes: {
      electric: 'Électrique',
      centralHeating: 'Chauffage central',
    },
    typeSection: 'Type',
    consumptionSection: 'Consommation',
    distributionSection: 'Système de distribution',
    greyWaterSection: 'Récupération de chaleur des eaux grises',
    tapFrequency: 'Fréquence de puisage',
    tapCyclesPerDay: 'Cycles de puisage par jour',
    hasCirculation: "Système d'eau chaude avec circulation",
    pipeSpecificLength: "Longueur spécifique des tuyaux d'ECS",
    circulationPipeLength: 'Longueur spécifique des tuyaux de circulation',
    greyWaterRecoveryType: 'Type de récupérateur',
    greyWaterEfficiencyGrade: 'Rendement instantané',
    greyWaterShareType: "Part d'eau chaude pour la récupération",
    greyWaterConnectionType: 'Variante de raccordement',
    greyWaterPatternType: 'Profil de puisage',
    greyWaterHelperText:
      "L'énergie récupérée des eaux grises est déduite de la demande énergétique totale pour le chauffage de l'eau chaude sanitaire.",
    tapFrequencyTypes: {
      high: 'Fréquence de puisage élevée',
      normal: 'Fréquence de puisage normale',
      low: 'Fréquence de puisage basse',
      perDay: '/jour',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Résidentiel, longs parcours de tuyaux',
      residentialNormal: 'Résidentiel, parcours de tuyaux normaux',
      residentialShort: 'Résidentiel, courts parcours de tuyaux',
      commercialLong: 'Commercial, longs parcours de tuyaux',
      commercialNormal: 'Commercial, parcours de tuyaux normaux',
      commercialShort: 'Commercial, courts parcours de tuyaux',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Système de circulation, longs parcours',
      circulationNormal: 'Système de circulation, parcours normaux',
      circulationShort: 'Système de circulation, courts parcours',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Échangeur de chaleur à tube vertical',
      horizontalPipe: 'Échangeur de chaleur horizontal',
      tankRecovery: 'Récupération de chaleur par réservoir',
    },
    greyWaterEfficiencyGrades: {
      low: 'Faible rendement',
      normal: 'Rendement normal',
      high: 'Rendement élevé',
    },
    greyWaterShareTypes: {
      allShowers: 'Toutes les douches vers la récupération',
      halfShowers: '50 % des douches vers la récupération',
      thirdShowers: '30 % des douches vers la récupération',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: "Raccordé au ballon d'eau chaude uniquement",
      coldWaterShowerOnly: "Raccordé au circuit d'eau froide douche uniquement",
      hotWaterTankAndColdWaterShower:
        "Raccordé au ballon d'eau chaude et au circuit d'eau froide douche",
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation:
        "Résidentiel avec accumulation d'eaux grises",
      residentialWithoutAccumulation:
        "Résidentiel sans accumulation d'eaux grises",
      showerWithoutAccumulation:
        "Installation de douches sans accumulation d'eaux grises",
      showerWithAccumulation:
        "Installation de douches avec accumulation d'eaux grises",
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: "Sources d'énergie locales",
    centralEnergySources: "Sources d'énergie centrales",
    noCentralModules: "Aucun module d'énergie centrale configuré",
    pipeConfiguration: 'Configuration des tuyaux',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Débit constant',
    variableFlow: 'Débit variable',
    lengthOfPipe: 'Longueur du tuyau (m)',
    percentageInHeatedSpace: "% dans l'espace chauffé",
    avgTempOutsideHeatedSpace: 'Temp. moy. hors espace chauffé (°C)',
    waterSystemQuality: 'Qualité du système hydraulique',
    waterDistributionType: "Type de distribution d'eau",
    pipeInsulationType: 'Isolation des tuyaux',
    qualityOptions: {
      poor: "Mauvaise distribution d'eau",
      normal: "Distribution d'eau normale",
      good: "Bonne distribution d'eau",
    },
    distributionTypes: {
      radiatorFloorHeating:
        'Système de chauffage, radiateur/plancher chauffant',
      heatingBattery:
        'Système de chauffage, batterie de chauffage en ventilation',
      localCoolingCeilingBaffles:
        'Système de refroidissement, refroidissement local/baffles plafond',
      centralCoolingBattery:
        'Système de refroidissement, batterie centrale en ventilation',
      dhwCirculation: 'Circulation ECS',
      energyWellBrine: 'Puits énergétique, saumure',
    },
    insulationTypes: {
      uninsulated: 'Tuyaux non isolés',
      poorlyInsulated: 'Tuyaux mal isolés',
      normallyInsulated: 'Tuyaux normalement isolés',
      wellInsulated: 'Tuyaux bien isolés',
      veryWellInsulated: 'Tuyaux très bien isolés',
    },
    distributionPipeLengthType: 'Longueur de tuyau par BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong:
        'Chauffage local et central, longs parcours de tuyaux',
      localAndCentralNormal:
        'Chauffage local et central, parcours de tuyaux normaux',
      centralOnlyLong: 'Chauffage central uniquement, longs parcours de tuyaux',
      centralOnlyShort:
        'Chauffage central uniquement, courts parcours de tuyaux',
    },
    temperatureCannotBeZero: 'La température ne peut pas être 0',
    pipeTemperatureZeroWarning:
      'La température aller et/ou retour est définie sur 0.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: "Supprimer l'équipement de production",
    confirmDelete: 'Supprimer cet équipement de production?',
    eligibleForHarvesting: "Éligible à la récupération d'énergie",
    eligibleForHarvestingHelp:
      "Marquer cet équipement comme éligible à la récupération d'énergie excédentaire",
  },

  // Central Energy Module
  centralEnergy: {
    mode: 'Mode',
    heatPumpTypeRequired:
      'Chaque pompe à chaleur a besoin d’un type de pompe à chaleur',
    heatPumpNominalLoadRequired:
      'Chaque pompe à chaleur a besoin d’une charge nominale supérieure à 0',
    heatPumpMinimumLoadRequired:
      'Chaque pompe à chaleur a besoin d’une charge minimale supérieure à 0',
    combustionBoilerTypeRequired:
      'Chaque chaudière à combustion a besoin d’un type de chaudière',
    combustionBoilerFuelSourceRequired:
      'Chaque chaudière à combustion a besoin d’une source de combustible',
    fillRequiredFields: 'Remplissez tous les champs obligatoires',
    requiredFieldsNotSaved:
      'Les modifications ne sont pas enregistrées tant que tous les champs obligatoires ne sont pas remplis',
    solarThermalSolarTypeRequired:
      'Chaque source solaire thermique a besoin d’un type de capteur',
    solarThermalCollectorAreaRequired:
      'Chaque source solaire thermique a besoin d’une surface de capteur supérieure à 0',
    otherSourceMaxCapacityRequired:
      'Chaque autre source a besoin d’une capacité maximale supérieure à 0',
    otherSourceEfficiencyRequired:
      'Chaque autre source a besoin d’un rendement supérieur à 0',
    heatingAndHotWater: 'Chauffage et eau chaude',
    thermalZone: 'Zone thermique',
    thermalZoneHelp: 'Lier à une zone thermique pour la température ambiante',
    noZone: 'Aucune (autonome)',
    selectZone: 'Sélectionner une zone...',
    ambientTemperature: 'Température ambiante',
    ambientTempHelp:
      "Température autour du module lorsqu'il n'est pas lié à une zone",
    moduleName: "Module d'énergie centrale",
    deleteModule: "Supprimer le module d'énergie centrale",
    confirmDelete:
      "Supprimer ce module d'énergie centrale et toutes les sources d'énergie?",
    notLinkedWarning:
      "Ce module n'est lié à aucun équipement. Ajoutez-le comme source d'énergie dans le chauffage/refroidissement, la ventilation, l'eau chaude sanitaire ou l'équipement de production.",
    notLinkedListWarning:
      "{name} n'est lié à aucun équipement. Ajoutez-le comme source d'énergie pour l'utiliser.",
    notesAttachments: 'Notes et pièces jointes',
    energySources: "Sources d'énergie",
    tanks: 'Réservoirs',
    performance: 'Rendement',

    // Accumulation tanks
    accumulationTanks: 'Ballons de stockage',
    addTank: 'Ajouter un réservoir',
    confirmDeleteTank: 'Supprimer ce ballon de stockage?',
    noTanks: 'Aucun ballon de stockage configuré. Cliquez pour en ajouter un.',
    dhwTank: 'ECS (eau chaude sanitaire)',
    heatingTank: 'Ballon tampon',
    coolingTank: 'Stockage de froid',
    insulation: 'Isolation',
    setpoint: 'Consigne (°C)',
    maxTemp: 'Temp max (°C)',
    minTemp: 'Temp min (°C)',
    heatLoss: 'Perte de chaleur (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: "Grade d'isolation chaudière",
    boilerInsulationVeryLow: 'Très mal isolée',
    selectBoilerInsulation: 'Sélectionner isolation...',

    // Energy source configuration
    energySourceConfig: "Configuration source d'énergie",
    sourceType: "Type de source d'énergie",
    selectType: "Sélectionner un type de source d'énergie...",
    sourceName: "Nom de la source d'énergie",
    usage: 'Utilisation',
    dhw: 'ECS',
    addToList: 'Ajouter à la liste',

    // Priority list
    priorityList: 'Liste de priorité',
    dragToReorder: 'Cliquer pour modifier. Glisser pour réorganiser',
    clickToEdit: 'Cliquer sur une source pour la modifier',
    confirmDeleteSource: "Supprimer cette source d'énergie?",
    noPrioritySources: "Aucune source d'énergie ajoutée",
    noSources:
      "Aucune source d'énergie ajoutée. Utilisez le formulaire ci-dessus pour ajouter des sources.",

    // Energy source types
    districtHeating: 'Chauffage urbain',
    combustionBoiler: 'Chaudière à combustion',
    electricBoiler: 'Chaudière électrique',
    otherSource: 'Autre source',

    // Heat pump fields
    heatPumpType: 'Type de pompe à chaleur',
    airToAir: 'Air-air',
    airToWater: 'Air-eau',
    liquidToWater: 'Eau-eau',
    heatingCapacity: 'Capacité de chauffage (kW)',
    liquidSource: 'Source liquide',
    selectSource: 'Sélectionner la source...',
    freshWater: 'Eau douce',
    seaWater: 'Eau de mer',
    sourceTemp: 'Temp. source (°C)',
    avgYearlyTemp: 'Temp. annuelle moy. (°C)',
    maxTemperatureSupplied: 'Température maximale fournie (°C)',
    SourceTempeAmplitude: 'Variation de température de la source (°C)',
    energyWellDimensioning:
      'Utilisation et dimensionnement du puits géothermique',
    energyWellHeatingOnlyUndersized:
      'Chauffage seul (extraction de chaleur), puits géothermique légèrement sous-dimensionné',
    energyWellHeatingOnlyGood:
      'Chauffage seul (extraction de chaleur), puits géothermique bien dimensionné',
    energyWellSomeCoolingUndersized:
      'Chauffage et un peu de refroidissement, puits géothermique légèrement sous-dimensionné',
    energyWellSomeCoolingGood:
      'Chauffage et un peu de refroidissement, puits géothermique bien dimensionné',
    energyWellBalancedUndersized:
      'Chauffage et refroidissement équilibrés, puits géothermique légèrement sous-dimensionné',
    energyWellBalancedGood:
      'Chauffage et refroidissement équilibrés, puits géothermique bien dimensionné',
    highestSourceTemperature:
      'Température de source la plus élevée fournie (°C)',
    waterSourceDepth: 'Profondeur du prélèvement de chaleur en mer/eau',
    CO2EmissionFactor: "Facteur d'émission CO₂ (g/kWh)",

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Capacité max (kW)',
    energyPrice: "Prix de l'énergie (par kWh)",
    temperatureFromSource: 'Température depuis la source (°C)',
    // Combustion boiler fields
    boilerType: 'Type de chaudière',
    biomass: 'Biomasse',
    fuelSource: 'Source de combustible',
    otherFuelSource: 'Autre',
    fuelType: 'Type de combustible',
    flueGasCondensation: 'Condensation des fumées',
    fuelConfig: 'Configuration du combustible',
    fuelEnergyContent: 'Contenu énergétique (kWh/L)',
    efficiencyLowLoad: 'Effet à 30% de charge (kW)',
    effectFullLoad: 'Effet à pleine charge (kW)',
    isCondensing: 'Chaudière à condensation',
    operatingSchedule: 'Calendrier de fonctionnement',
    startDate: 'Début (jour/mois)',
    endDate: 'Fin (jour/mois)',
    startOfDay: 'Heure de début',
    endOfDay: 'Heure de fin',
    seasonalMeanTemp: 'Température moyenne saisonnière (°C)',

    // Solar thermal fields
    solarType: 'Type solaire',
    vacuumTube: 'Tube sous vide',
    flatPlate: 'Capteur plan',
    tilt: 'Inclinaison (°)',
    area: 'Surface totale (m²)',
    collectorArea: 'Surface de capteur (m²)',
    pipeLength: 'Longueur de tuyau (m)',
    pipeUValue: 'Valeur U du tuyau (W/mK)',
    collectorSpecs: 'Spécifications du capteur',
    efficiencyNormal: 'Rendement η₀',
    heatLossLinear: 'Perte de chaleur a₁ (W/m²K)',
    heatLossSecond: 'Perte de chaleur a₂ (W/m²K²)',
    opticalEfficiency: 'Rendement optique',
    heatLossCoeff: 'Coefficient de perte de chaleur',
    shadingWinter: "Facteur d'ombrage hiver",
    shadingSummer: "Facteur d'ombrage été",
    adjustmentFactor: "Facteur d'ajustement",
    tankSpiralPlacementFactor:
      'Facteur de positionnement du serpentin du ballon',
    temperatureColdWater: "Température de l'eau froide (°C)",
    temperatureInCollectionTank: 'Température du ballon de stockage (°C)',
    percentageOfCollectorLoopOutside:
      "Part du circuit capteur à l'extérieur (%)",
    snowCoverageMonths: 'Mois avec couverture neigeuse',
    selectMonths: 'Sélectionner les mois...',
    insulationFactorForCollectionLoop: "Facteur d'isolation du circuit capteur",
    selectInsulationFactorForCollectionLoop:
      "Sélectionner le facteur d'isolation...",

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: "Isolation de l'échangeur de chaleur",
    selectHeatExchangerInsulation: "Sélectionner l'isolation...",
    outletTemperatureRange: 'Plage de température de sortie',
    selectOutletTempRange: 'Sélectionner la plage...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Perte échangeur de chaleur',
    bdhValue: 'Coefficient de perte',
    supplyTemperatureRange: "Plage de température d'alimentation",
    selectSupplyTempRange: 'Sélectionner la plage...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Perte de distribution',
    ddhValue: 'Coefficient de perte',
    coolingHeatExchangerInsulation: 'Isolation échangeur de refroidissement',
    selectCoolingHxInsulation: "Sélectionner l'isolation...",
    coolingHeatExchangerUValue: 'Échangeur de refroidissement',
    coolingHxUValue: 'Valeur U (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Cogénération (CHP)',
    chpSettings: 'Paramètres CHP',
    chpFuelType: 'Type de combustible CHP',
    selectChpFuelType: 'Sélectionner le combustible...',
    chpSolidFuel: 'Combustible solide',
    chpLiquidFuel: 'Combustible liquide',
    chpGas: 'Gaz',
    chpPerformanceLevel: 'Niveau de performance',
    selectChpPerformance: 'Sélectionner la performance...',
    chpThermalEfficiency: 'Rendement thermique (%)',
    chpElectricalEfficiency: 'Rendement électrique (%)',
    chpTotalEfficiency: 'Rendement total (%)',
    chpBoilerType: 'Type de chaudière CHP',
    selectChpBoilerType: 'Sélectionner le type de chaudière...',
    chpBiopellets: 'Bio-granulés',
    chpWoodChips: 'Copeaux de bois',
    gasOrOilBoiler: 'Chaudière gaz ou fioul',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: "Type d'isolation des tuyaux",
    selectPipeInsulation: "Sélectionner l'isolation...",
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: "Éligible à la récupération d'énergie",
    eligibleForHarvestingHelp:
      "Marquer ce module comme éligible à la récupération d'énergie excédentaire",

    // Duct dimensions
    ductDimensions: 'Dimensions des conduits',
    ductShape: 'Forme du conduit',
    diameter: 'Diamètre (mm)',
    width: 'Largeur (mm)',
    height: 'Hauteur (mm)',
    airspeed: "Vitesse de l'air (m/s)",

    // Flow properties
    flowProperties: "Propriétés d'écoulement",
    temperature: "Température d'extraction (C)",
    volumeFlow: 'Débit volumique',
    volumeFlowAir: 'Débit volumique (m³/h)',
    volumeFlowLiquid: 'Débit volumique (L/h)',

    // Delete
    deleteModule: "Supprimer le module d'énergie excédentaire",
    confirmDelete: "Supprimer ce module d'énergie excédentaire?",
    noModuleFound: "Module d'énergie excédentaire non trouvé",
  },

  // Solar PV Module
  solarPv: {
    soilingFactors: "Facteurs d'encrassement (\u03C6_soil)",
    panelProperties: 'Propriétés du panneau',
    lossesCoefficients: 'Pertes et coefficients',
    panelAngle: 'Angle du panneau',
    tiltRange: "Plage d'inclinaison : {range}°",
    angleOutOfRange: 'Angle hors plage',
    selectLocation: "Sélectionner l'emplacement...",
    usingStandardTable:
      "Utilisation du tableau {standard} pour la plage d'inclinaison {range}°",
    selectCellType: 'Sélectionner le type de cellule...',
    nominalEfficiency: 'Rendement nominal (0-1)',
    panelAzimuth: 'Azimut du panneau (0-360°)',
    shadingFactor: "Facteur d'ombrage (0-1)",
    mountingType: 'Type de montage',
    selectMountingType: 'Sélectionner le type de montage...',
    windExposure: 'Exposition au vent',
    selectWindExposure: "Sélectionner l'exposition au vent...",
    heatLossFactor: 'Facteur de perte thermique (W/m²K)',
    inverterEfficiency: "Rendement de l'onduleur (0-1)",
    degradationLoss: 'Perte de dégradation (0-1)',
    inverterLoss: "Perte de l'onduleur (0-1)",
    transmissionProduct: 'Produit de transmission (0-1)',
    temperatureCoefficient: 'Coefficient de température (%/°C)',
    incidentAngleModifier: "Modificateur d'angle d'incidence (0-1)",
    deleteModule: 'Supprimer le module photovoltaïque',
    confirmDelete: 'Supprimer ce module photovoltaïque ?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      "Les batteries ne sont actuellement prises en compte que dans les simulations annuelles. Elles ne sont pas encore incluses dans le calcul de l'étiquette énergétique.",
    maxCapacity: 'Capacité max (kWh)',
    maxChargePower: 'Puissance de charge max (kW)',
    maxDischargePower: 'Puissance de décharge max (kW)',
    chargeEfficiency: 'Rendement de charge (0-1)',
    dischargeEfficiency: 'Rendement de décharge (0-1)',
    minStateOfCharge: 'État de charge min (0-1)',
    maxStateOfCharge: 'État de charge max (0-1)',
    peakShavingThreshold: "Seuil d'écrêtage des pointes (kW)",
    preChargeStateOfCharge: 'État de charge de précharge (0-1)',
    maxCapacityRequired: 'Une capacité max supérieure à 0 est requise',
    maxChargePowerRequired:
      'Une puissance de charge max supérieure à 0 est requise',
    maxDischargePowerRequired:
      'Une puissance de décharge max supérieure à 0 est requise',
    deleteBattery: 'Supprimer la batterie',
    confirmDelete: 'Supprimer cette batterie ?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Équilibré',
    exhaust: 'Extraction',
    supply: 'Soufflage',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: "Supprimer l'unité CVC",
    confirmDelete: 'Supprimer cette unité CVC?',
    heatRecoveryShort: 'Récupération de chaleur',
    airVolumeShort: "Débit d'air",
    addDxSystem: 'Ajouter un système DX',
    confirmDeleteDxSystem: 'Supprimer ce système DX?',
    addHeatingBattery: 'Ajouter une batterie de chauffage',
    confirmDeleteHeatingBattery: 'Supprimer cette batterie de chauffage?',
    addCoolingBattery: 'Ajouter une batterie de refroidissement',
    confirmDeleteCoolingBattery: 'Supprimer cette batterie de refroidissement?',

    // Section headers
    namePlaceholder: 'Nom de la centrale',
    dxSystemNamePlaceholder: 'Nom du système DX',
    batteryNamePlaceholder: 'Nom de la batterie',
    flowSfpSettings: "Débit d'air et paramètres SFP",
    temperatureMeasurements: 'Mesures de température',
    dxSystems: 'DX (Détente directe)',
    heatingBatteries: 'Batteries de chauffage',
    coolingBatteries: 'Batteries de refroidissement',
    naturalVentilation: 'Ventilation naturelle',

    // SFP fields
    sfpCalculationMethod: 'Méthode de calcul SFP',
    sfpAsFunction: 'Puissance spécifique du ventilateur',
    yearBands: {
      pre1985: 'Avant 1985',
      '1985to1995': '1985 à 1995',
      '1995to2005': '1995 à 2005',
      '2005to2013': '2005 à 2013',
      '2013to2020': '2013 à 2020',
      from2020: '2020 et plus récent',
    },
    suggestions: {
      yearHelp:
        "L'année d'installation de la centrale de ventilation. Elle détermine le type de moteur, le SFP et la récupération de chaleur typiques de la période.",
      hintLabel: 'Suggestion',
      calculatedLabel: 'Calculé',
      apply: 'Utiliser',
      applyAll: 'Utiliser ({count}) suggestions',
      noSuggestions: 'Aucune suggestion',
      applyAllHelp: 'Appliquer toutes les valeurs suggérées sur cette page.',
    },

    // Flow fields
    fanPower: 'Puissance ventilateur',
    coverage: 'Couverture',
    fanPowerIn: 'Puissance ventilateur entrant (kW)',
    fanPowerOut: 'Puissance ventilateur sortant (kW)',
    supplyAirVolume: 'Supply Air Volume',
    airVolumeOperating: 'Operating (m³/h)',
    airVolumeCapacity: 'Capacity (m³/h)',
    airVolumeNonOperating: 'Non-Operating (m³/h)',
    extractionAirVolume: 'Extraction Air Volume',
    airVolumeExtractionOperating: 'Operating (m³/h)',
    airVolumeExtractionCapacity: 'Capacity (m³/h)',
    airVolumeExtractionNonOperating: 'Non-Operating (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Type de récupération de chaleur',
    efficiencyHR: 'Rendement RC (%)',
    frostProtection: 'Protection antigel',
    frostProtectionTemperature: 'Température de protection antigel (°C)',

    // Temperature
    measuredSupplyTemp: 'Temp. soufflage mesurée (°C)',
    measuredExhaustTemp: 'Temp. extraction mesurée (°C)',

    // DX System
    dxSystem: 'Système DX',
    dxType: 'Type',

    // Battery fields
    heatingBattery: 'Batterie de chauffage',
    coolingBattery: 'Batterie de refroidissement',
    batteryType: 'Type',

    // Priority lists
    heatingPriorityList: 'Priorité de chauffage',
    coolingPriorityList: 'Priorité de refroidissement',
    priorityListHelp: 'Glisser pour réorganiser la priorité pour les calculs',
    noPriorityItems: 'Aucun élément configuré',

    // zone linking
    linkedZones: 'Zones liées',
    noLinkedZones: 'Aucune zone liée',
    manageZones: 'Gérer les zones',
    useZoneMap: 'Utiliser la carte des zones',
    linkZonesTitle: 'Lier les zones thermiques',
    noZonesAvailable: 'Aucune zone thermique disponible',
    zonesLinked: 'Zones liées avec succès',
    noZoneWarning: "Cette unité CVC n'est pas liée à une zone thermique.",
    noZoneListWarning: "{name} n'est pas lié à une zone thermique.",
    sfp100Required: 'Un SFP @ 100 % supérieur à 0 est requis',
    airVolumeOperatingRequired:
      "Un volume d'air de soufflage en fonctionnement supérieur à 0 est requis",
    airVolumeCapacityRequired:
      "Un volume d'air de soufflage en capacité supérieur à 0 est requis",
    airVolumeExtractionOperatingRequired:
      "Un volume d'air d'extraction en fonctionnement supérieur à 0 est requis",
    dxEnergySourceRequired: "Chaque système DX a besoin d'une source d'énergie",
    dxSystemEfficiencyRequired:
      "Chaque système DX a besoin d'un rendement de système supérieur à 0",
    heatingBatteryPowerRequired:
      "Chaque batterie de chauffage a besoin d'une puissance supérieure à 0",
    heatingBatterySystemEfficiencyRequired:
      "Chaque batterie de chauffage a besoin d'un rendement de système supérieur à 0",
    heatingBatteryEnergySourceRequired:
      "Chaque batterie de chauffage a besoin d'une source d'énergie",
    coolingBatteryPowerRequired:
      "Chaque batterie de refroidissement a besoin d'une puissance supérieure à 0",
    coolingBatterySystemEfficiencyRequired:
      "Chaque batterie de refroidissement a besoin d'un rendement de système supérieur à 0",
    coolingBatteryEnergySourceRequired:
      "Chaque batterie de refroidissement a besoin d'une source d'énergie",

    supplementaryFactor: 'Facteur supplémentaire',

    motorType: 'Type de moteur',
    motorTypes: {
      none: 'Aucun',
      belt: 'Entraînement par courroie',
      axial: 'Ventilateur axial',
      EC: 'Moteur EC',
      AC: 'Moteur AC',
      DC: 'Moteur DC',
      VSD: 'Variateur de vitesse (VSD)',
      other: 'Autre',
    },

    dxTypes: {
      cooling: 'Refroidissement uniquement',
      heating: 'Chauffage uniquement',
      both: 'Chauffage et refroidissement',
    },

    flowTypes: {
      variable: 'Débit variable',
      constant: 'CAV, débit constant',
      optimal: 'DCV, à la demande',
    },

    batteryTypes: {
      water: 'Eau',
      electric: 'Électrique',
      heatPump: 'Pompe à chaleur',
      other: 'Autre',
    },

    heatRecoveryTypes: {
      rotaryWheel: 'Échangeur rotatif',
      crossFlow: 'Échangeur à plaques à flux croisés',
      plateCounterflow: 'Échangeur à plaques à contre-courant',
      runAroundCoil: "Circuit à boucle d'eau",
      heatPipe: 'Caloduc',
      none: 'Aucun',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Nom du mur',
    direction: 'Direction',
    type: 'Type de mur',
    shadingFactor: "Facteur d'ombrage",
    deleteWall: 'Supprimer le mur',
    confirmDelete: 'Supprimer ce mur?',
    directionRequired: 'Veuillez sélectionner une direction de mur',
    areaRequired: 'Une surface de mur supérieure à 0 est requise',
    uValueRequired: 'Une valeur U supérieure à 0 est requise',
    windowsExceedArea:
      'La surface totale des fenêtres dépasse la surface du mur.',
    doorsExceedArea: 'La surface totale des portes dépasse la surface du mur.',
    gatesExceedArea:
      'La surface totale des portails dépasse la surface du mur.',
    combinedExceedArea:
      'La surface combinée des fenêtres, portes et portails dépasse la surface du mur.',
    windowsExceedAreaList:
      '{name} : la surface totale des fenêtres dépasse la surface du mur.',
    doorsExceedAreaList:
      '{name} : la surface totale des portes dépasse la surface du mur.',
    gatesExceedAreaList:
      '{name} : la surface totale des portails dépasse la surface du mur.',
    combinedExceedAreaList:
      '{name} : la surface combinée des fenêtres, portes et portails dépasse la surface du mur.',
    options: {
      custom: 'Personnalisé',
      standard: 'Standard',
      timberFrame36_150: 'Ossature bois 36mm, 150mm isolation',
      timberFrame36_200: 'Ossature bois 36mm, 200mm isolation',
      timberFrame36_250: 'Ossature bois 36mm, 250mm isolation',
      timberFrame48_150: 'Ossature bois 48mm, 150mm isolation',
      timberFrame48_200: 'Ossature bois 48mm, 200mm isolation',
      timberFrame48_250: 'Ossature bois 48mm, 250mm isolation',
      epsBlock310: 'Bloc EPS 310mm (noyau béton 140mm)',
      epsBlock370: 'Bloc EPS 370mm (noyau béton 140mm)',
      epsBlock430: 'Bloc EPS 430mm (noyau béton 140mm)',
      iProfile200: 'Profil I acier, 200mm isolation',
      iProfile300: 'Profil I acier, 300mm isolation',
      iProfile400: 'Profil I acier, 400mm isolation',
      lwaBlock250: 'Bloc agrégats légers (Isoblokk) 250mm',
      lwaBlock300: 'Bloc agrégats légers (Isoblokk) 300mm',
      lwaBlock350: 'Bloc agrégats légers (Isoblokk) 350mm',
      slottedSteel200: 'Acier perforé, 200mm isolation',
      slottedSteel250: 'Acier perforé, 250mm isolation',
      slottedSteel300: 'Acier perforé, 300mm isolation',
      unslottedSteel200: 'Acier non-perforé, 200mm isolation',
      unslottedSteel250: 'Acier non-perforé, 250mm isolation',
      unslottedSteel300: 'Acier non-perforé, 300mm isolation',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Petite maison',
      apartmentBlock: 'Immeuble',
      kindergarten: 'Crèche',
      officeBuilding: 'Bureau',
      schoolBuilding: 'École',
      universityCollege: 'Université/Grande école',
      hospital: 'Hôpital',
      nursingHome: 'Maison de retraite',
      hotelBuilding: 'Hôtel',
      sportsBuilding: 'Sports',
      commercialBuilding: 'Commercial',
      culturalBuilding: 'Culture',
      lightIndustry: 'Industrie légère/Entrepôt',
    },
    description: {
      smallHouse:
        'Maison individuelle, maison jumelée, maison en rangée ou autre petit bâtiment résidentiel.',
      apartmentBlock: 'Immeuble résidentiel avec deux étages ou plus.',
      kindergarten:
        "Bâtiment destiné à la crèche ou à l'éducation de la petite enfance.",
      officeBuilding:
        "Bureaux simples, bureaux climatisés ou bâtiments d'exposition/congrès.",
      schoolBuilding:
        "Locaux d'enseignement, y compris écoles avec piscine ou salle de sport.",
      universityCollege:
        'Bâtiments universitaires, laboratoires ou installations de recherche.',
      hospital:
        'Hôpitaux, hôtels hospitaliers ou bâtiments de laboratoire médical.',
      nursingHome: 'Maisons de retraite pour soins de longue durée.',
      hotelBuilding: "Hôtels, restaurants ou autres bâtiments d'hébergement.",
      sportsBuilding:
        'Salles de sport, piscines et autres installations sportives avec vestiaires.',
      commercialBuilding:
        'Commerces, magasins avec chambres froides ou stations-service.',
      culturalBuilding:
        'Cinémas, musées, bibliothèques et bâtiments religieux.',
      lightIndustry:
        'Bâtiments industriels, entrepôts, bâtiments agricoles ou autres ateliers.',
    },
  },

  buildingSubcategories: {
    1: 'Maison individuelle',
    2: 'Maison individuelle avec unité locative',
    3: 'Maison jumelée (horizontale)',
    4: 'Maison jumelée (verticale)',
    5: 'Maison à quatre logements',
    6: 'Maison en chaîne',
    7: 'Maison en rangée',
    8: 'Maison de vacances',
    9: 'Autre petite maison',
    10: 'Appartement',
    11: 'Autre logement',
    12: 'Bâtiment de crèche',
    13: 'Bureaux simples',
    14: 'Bureaux avec ventilation et climatisation',
    15: 'Bâtiment de foire/congrès',
    16: 'Autre bâtiment de bureaux',
    17: "Locaux d'enseignement",
    18: 'École avec piscine',
    19: 'École avec salle de sport',
    20: "Bâtiment d'enseignement",
    21: 'Bâtiment de laboratoire',
    22: 'Autre bâtiment de recherche',
    23: 'Hôpital',
    24: 'Hôtel hospitalier',
    25: 'Laboratoire hospitalier',
    26: 'Maison de retraite',
    27: 'Bâtiment hôtelier',
    28: "Bâtiment d'hébergement",
    29: 'Bâtiment de restaurant',
    30: 'Autre bâtiment hôtelier',
    31: 'Salle de sport',
    32: 'Salle de sport avec douches',
    33: 'Salle de sport avec piscine',
    34: 'Magasin',
    35: 'Magasin avec chambre froide',
    36: 'Station-service',
    37: 'Bâtiment culturel',
    38: 'Cinéma',
    39: 'Musée/bibliothèque',
    40: 'Bâtiment pour activités religieuses',
    41: 'Bâtiment industriel',
    42: "Bâtiment d'approvisionnement énergétique",
    43: 'Entrepôt',
    44: 'Bâtiment de pêche/agriculture',
    45: 'Autre industrie',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Planning de chauffage',
      coolingSchedule: 'Planning de refroidissement',
      addHeatingSchedule: 'Ajouter un programme de chauffage',
      addCoolingSchedule: 'Ajouter un programme de refroidissement',
    },
    yearPeriods: {
      TEK50: 'Avant 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: '2017 et après',
    },
    hasFloorToGround: 'La zone a un plancher sur le sol',
    hasRoof: 'La zone a un toit',
    isBasement: 'La zone est un sous-sol',
    floor: {
      type: 'Type de plancher sur le sol',
      area: 'Plancher sur le sol (m²)',
      options: {
        custom: 'Personnalisé',
        standard: 'Standard',
        tiles: 'Carrelage sur béton',
        parquetChipBoard: 'Parquet sur aggloméré',
        carpetConcrete: 'Moquette sur béton',
      },
    },
    roof: {
      type: 'Type de toiture',
      optionsTitle: 'Construction de toiture',
      angle: 'Angle du toit',
      hasWindows: 'Le toit a des fenêtres',
      areaRequired: 'Une surface de toit supérieure à 0 est requise',
      windowArea: 'Surface vitrée (m²)',
      glassType: 'Type de vitrage',
      pitchTypes: {
        flat: 'Toit plat',
        lowSlope: 'Faible pente',
        gentlePitch: 'Pente douce',
        standardPitch: 'Pente standard',
        steepPitch: 'Pente raide',
        verySteepPitch: 'Pente très raide',
      },
      options: {
        custom: 'Personnalisé',
        standard: 'Standard',
        compactConcrete200: 'Toiture-terrasse, béton, 200mm isolation',
        compactConcrete300: 'Toiture-terrasse, béton, 300mm isolation',
        compactConcrete400: 'Toiture-terrasse, béton, 400mm isolation',
        compactSteel200: 'Toiture-terrasse, acier, 200mm isolation',
        compactSteel300: 'Toiture-terrasse, acier, 300mm isolation',
        compactSteel400: 'Toiture-terrasse, acier, 400mm isolation',
        pitched48mm200: 'Toiture inclinée, chevrons 48mm, 200mm isolation',
        pitched48mm300: 'Toiture inclinée, chevrons 48mm, 300mm isolation',
        pitched48mm400: 'Toiture inclinée, chevrons 48mm, 400mm isolation',
        pitchedIBeam200: 'Toiture inclinée, poutres en I, 200mm isolation',
        pitchedIBeam300: 'Toiture inclinée, poutres en I, 300mm isolation',
        pitchedIBeam450: 'Toiture inclinée, poutres en I, 450mm isolation',
        coldAttic200: 'Combles froids, 200mm isolation',
        coldAttic300: 'Combles froids, 300mm isolation',
        coldAttic450: 'Combles froids, 450mm isolation',
      },
    },
    basement: {
      dimensions: 'Dimensions',
      area: 'Surface de plancher contre le sol (m²)',
      wallPerimeter: 'Périmètre de mur enterré (m)',
      fillHeight: 'Profondeur sous le terrain (m)',
      wallThickness: 'Épaisseur du mur (m)',
      wallConstruction: 'Mur de sous-sol',
      wallConstructionType: 'Type de mur',
      wallUValue: 'Valeur U du mur (W/m²K)',
      floorConstruction: 'Plancher de sous-sol',
      floorConstructionType: 'Type de plancher',
      floorUValue: 'Valeur U du plancher (W/m²K)',
      intro:
        'Pensez à réduire le plancher sur sol de la zone située au-dessus de la surface du sous-sol.',
      floorConstructionOptions: {
        none: 'Aucun',
        standard: 'Standard',
        concrete100: 'Béton sur sol avec 100mm isolation',
        concrete150: 'Béton sur sol avec 150mm isolation',
        concrete200: 'Béton sur sol avec 200mm isolation',
        concrete250: 'Béton sur sol avec 250mm isolation',
        concrete300: 'Béton sur sol avec 300mm isolation',
        concrete350: 'Béton sur sol avec 350mm isolation',
        concrete400: 'Béton sur sol avec 400mm isolation',
        wood200: 'Solives en bois avec 200mm isolation',
        wood250: 'Solives en bois avec 250mm isolation',
        wood300: 'Solives en bois avec 300mm isolation',
      },
    },
    groundConditions: {
      type: 'Type de sol',
      thermalConductivity: 'Conductivité thermique λ (W/(m·K))',
      heatCapacity: 'Capacité thermique Cv (Wh/(m³·K))',
      penetrationDepth: 'Profondeur de pénétration périodique δ (m)',
      options: {
        clay: 'Argile/limon',
        sand: 'Sable/gravier',
        rock: 'Roche',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Capacité thermique de la zone',
      heatCapacityCategory: 'Catégorie de capacité thermique',
      normalizedHeatCapacity: 'Capacité thermique normalisée (Wh/m²K)',
      interiorWalls: 'Murs intérieurs',
      cladding: 'Revêtement',
      heatCapacity: 'Capacité thermique (Wh/m²K)',
      furniture: 'Mobilier',
      furnitureGrade: 'Grade du mobilier',
      massFactor: 'Facteur de masse (Wh/m²K)',
      heatCapacityCategoryRequired:
        'Veuillez sélectionner une catégorie de capacité thermique',
      claddingRequired: 'Veuillez sélectionner un type de revêtement',
      furnitureGradeRequired: 'Veuillez sélectionner un grade de mobilier',
      labelFirstOption: 'Zone très légère',
      labelSecondOption: 'Zone légère',
      labelThirdOption: 'Zone moyennement lourde',
      labelFourthOption: 'Zone lourde',
      labelFifthOption: 'Zone très lourde',
      shortDescriptionFirstOption:
        'Plancher à solives légères, revêtement mince, murs légers',
      shortDescriptionSecondOption:
        'Plafond acoustique, moquette sur béton, murs légers',
      shortDescriptionThirdOption:
        'Peu de béton exposé (20%), parquet sur béton',
      shortDescriptionFourthOption: 'Béton principalement exposé (70%)',
      shortDescriptionFifthOption: 'Béton exposé au plafond, murs et sol',
      claddingOptions: {
        custom: 'Personnalisé',
        standard: 'Standard',
        concrete100: '100mm (ou plus) béton',
        concrete80: '80mm béton',
        aeratedConcrete: 'Béton cellulaire',
        gypsum13: 'Gypse 13mm',
        lightBrick: 'Brique légère',
        lwa: 'Granulat léger',
        solidWood40: 'Bois massif (épaisseur > 40mm)',
        woodPanel15: 'Panneau bois 15mm',
        heavyBrick: 'Brique lourde (compacte)',
      },
      furnitureOptions: {
        none: 'Aucun',
        standard: 'Standard',
        light: 'Léger',
        medium: 'Moyen',
        heavy: 'Lourd',
      },
    },
    airLeakage: {
      tekStandard: 'Norme TEK',
      n50: 'Taux de fuite n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Règlement de construction 1950–1969',
        TEK70: 'Règlement de construction 1970–1979',
        TEK80: 'Règlement de construction 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Supprimer la fenêtre',
      confirmDelete: 'Supprimer cette fenêtre?',
      gValue: 'Valeur g',
      frameFraction: 'Facteur de cadre',
      shadingFactor: "Facteur d'ombrage (0-1)",
      externalBlinds: 'Stores extérieurs (gt)',
      externalBlindsGt: 'Stores extérieurs gt',
      externalScreen: 'Toile extérieure (gt)',
      externalScreenGt: 'Toile extérieure gt',
      internalShading: 'Protection solaire intérieure (gt)',
      internalShadingGt: 'Protection solaire intérieure gt',
      windowTypes: {
        none: 'Aucun',
        custom: 'Personnalisé',
        singleGlass: 'Simple vitrage',
        twoLayerGlass: 'Double vitrage couplé',
        twoLayerEnergyGlass: 'Double vitrage à faible émissivité',
        twoLayerSolarReflective: 'Double vitrage réfléchissant',
        threeLayerEnergyGlass: 'Triple vitrage à faible émissivité',
      },
    },
    doors: {
      deleteDoor: 'Supprimer la porte',
      confirmDelete: 'Supprimer cette porte?',
      type: 'Type de porte',
      doorTypes: {
        custom: 'Personnalisé',
        standard: 'Standard',
        insulated: 'Isolée',
        normal: 'Normal',
        wellInsulated: 'Bien isolée',
        uninsulated: 'Non isolée',
      },
    },
    gates: {
      deleteGate: 'Supprimer le portail',
      confirmDelete: 'Supprimer ce portail?',
      type: 'Type de portail',
      gateTypes: {
        custom: 'Personnalisé',
        standard: 'Standard',
        insulated: 'Isolé',
        sectional: 'Porte sectionnelle',
        roller: 'Porte à enroulement',
        wellInsulated: 'Bien isolé',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        "Ces valeurs ne sont pas utilisées lors de la création de l'étiquette énergétique. Seule la détection de présence pour l'éclairage est prise en compte.",
      hotWater: 'Eau chaude',
      equipment: 'Équipement technique',
      occupancy: 'Personnes',
      weekday: 'Jour de semaine (260 jours)',
      weekend: 'Week-end (105 jours)',
      resetToStandards: 'Réinitialiser selon',
      hourlyProfile: 'Profil horaire',
      editHourlyValues: 'Modifier les valeurs horaires',
      peak: 'Pic',
      avg: 'Moy.',
      daily: 'Journalier',
      annual: 'Annuel',
      appliances: 'Électroménager',
      appliancesDescription:
        "Réduire la consommation électrique en raccordant les appareils à l'eau chaude.",
      dishwasherLabel: 'Lave-vaisselle (eau chaude)',
      washingMachineLabel: 'Lave-linge (eau chaude)',
      tumbleDryerLabel: 'Sèche-linge (eau chaude)',
      applianceShareLabel: 'Part thermique [%]',
      heatGainShareLabel: 'Apport de chaleur à la zone [1-100%]',
      lampTypes: 'Types de lampes',
      lampType: 'Type de lampe',
      selectLampType: 'Sélectionner le type de lampe',
      ballast: 'Ballast',
      electronic: 'Électronique',
      electromechanical: 'Électromécanique',
      sharePercent: 'Part (%)',
      efficiencyFactorFL: "Facteur d'efficacité (FL)",
      lampTypeNames: {
        ledNew: 'LED à partir de 2016 et plus récent',
        ledOld: 'LED de 2010–2015',
        fluorescentT5: 'Tube fluorescent T5',
        fluorescentT8: 'Tube fluorescent T8',
        metalHalide: 'Lampe aux halogénures métalliques',
        highPressureSodium: 'Lampe sodium haute pression',
        compactFluorescent: 'Lampe fluorescente compacte',
        halogen: 'Lampe halogène',
        incandescent: 'Lampe à incandescence',
      },
      addLampType: 'Ajouter un type de lampe',
      deleteLampType: 'Supprimer ce type de lampe ?',
    },
    heatingEmissionSystem: "Système d'émission de chaleur",
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Radiateur/convecteur avec vanne thermostatique ou régulateur local',
      radiator_thermostat_60_40:
        'Radiateur/convecteur avec vanne thermostatique ou régulateur local',
      radiator_thermostat_40_35:
        'Radiateur/convecteur avec vanne thermostatique ou régulateur local',
      radiator_sd_80_60: 'Radiateur/convecteur connecté à la GTC',
      radiator_sd_60_40: 'Radiateur/convecteur connecté à la GTC',
      radiator_sd_40_35: 'Radiateur/convecteur connecté à la GTC',
      fan_coil_heat_pump:
        'Ventilo-convecteur / pompe à chaleur / poutre froide active / chauffage par air soufflé',
      floor_heating_thermostat:
        'Plancher chauffant avec vanne thermostatique ou régulateur local',
      floor_heating_sd: 'Plancher chauffant connecté à la GTC',
      panel_heater_pre_2010: 'Panneau radiant – avant 2010',
      panel_heater_post_2010: 'Panneau radiant – après 2010',
    },
    coolingEmissionSystem: "Système d'émission de froid",
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Poutre froide passive avec vanne thermostatique ou régulateur local',
      chilled_beam_sd: 'Poutre froide passive connectée à la GTC',
      fan_coil_cool_pump:
        'Poutre froide active / ventilo-convecteur avec régulateur local',
      fan_coil_cool_pump_sd:
        'Poutre froide active / ventilo-convecteur connecté à la GTC',
      floor_cooling_thermostat: 'Plancher rafraîchissant avec régulateur local',
      floor_cooling_sd: 'Plancher rafraîchissant connecté à la GTC',
      chilled_ceiling_thermostat: 'Plafond froid avec régulateur local',
      chilled_ceiling_sd: 'Plafond froid connecté à la GTC',
    },
    effectiveSetpoint: 'Consigne effective',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Lier les zones',
    resetLayout: 'Réinitialiser la disposition',
    resetLayoutConfirm:
      'Réinitialiser la disposition de la carte ? Toutes les zones reviennent au placement suggéré.',
    confirmLink: 'Confirmer la liaison',
    linkDialogTitle: 'Lier les zones thermiques',
    linkingZones: 'Liaison des zones',
    sourceZone: 'Zone source',
    targetZones: 'Zones cibles',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst:
      "Sélectionnez d'abord la zone source, puis les zones cibles",
    minTwoZones: 'Sélectionnez au moins 2 zones à lier',
    linkSuccess: 'Zones liées avec succès',
    externalZone: 'Zone externe',
    zoneConnections: 'Couplage de zone',
    addConnection: 'Ajouter un couplage',
    noConnections: 'Aucun couplage de zone',
    connectionDeleted: 'Couplage supprimé',
    deleteConnectionError: 'Impossible de supprimer la liaison',
    connectionAdded: 'Couplage ajouté',
    connectionUpdated: 'Couplage mis à jour',
    editConnection: 'Modifier le couplage',
    deleteConnection: 'Supprimer le couplage',
    confirmDeleteConnection: 'Supprimer le couplage de zone ?',
    connectToExisting: 'Zone existante',
    connectToExternal: 'Zone externe',
    chooseConnectionType: 'Connecter à',
    zoneMap: 'Carte des zones',
    zoneMapEmpty: 'Aucune liaison de zones',
    notLinked: 'Non liée',
    autoLinked: 'Liée automatiquement',
    linkModeHintSource: 'Cliquez sur la zone source',
    deleteModeHint:
      'Cliquez sur la zone dont vous voulez supprimer les liaisons',
    ventilation: 'Ventilation',
    zoneMapSubtitle: 'Déplacez les zones pour ajuster la disposition.',
    noVentilationUnits: 'Aucune unité de ventilation disponible',
    noHeatingCoolingModules: 'Aucun chauffage ou refroidissement disponible',
    linkAny: 'Lier',
    linkModeHintSourceAny: 'Cliquez sur la source',
    linkModeHintTargetAny:
      'Cliquez sur la cible, ou choisissez une zone externe',
    deleteModeHintAny:
      "Cliquez sur la zone ou l'unité de ventilation dont vous voulez supprimer les liaisons",
    linkModeHintTarget:
      'Cliquez sur la zone cible ou choisissez une zone externe',
  },

  analytics: {
    energyToggle: 'Énergie',
    analyticsToggle: 'Analyse',
    compareToggle: 'Comparer',
    runSimulation: 'Lancer la simulation',
    runCoverNeedSimulation: 'Lancer la simulation aux exigences minimales',
    coverNeedTooltip:
      'Exécute la simulation avec des systèmes fictifs au niveau des exigences minimales, couvrant tout le besoin énergétique lorsque des systèmes manquent ou sont insuffisants',
    coverNeedAssumptionsTitle:
      'Hypothèses de la simulation aux exigences minimales',
    simulating: 'Simulation en cours...',
    exportToExcel: 'Exporter vers Excel',
    sendToEnova: 'Envoyer à Enova',
    resendToEnova: 'Renvoyer à Enova',
    downloadEnovaPdf: 'Télécharger le PDF Enova',
    sentToEnovaSuccess: 'Envoyé à Enova',
    sendToEnovaError: "Échec de l'envoi à Enova",
    simulationStartedRefresh:
      'Les calculs ont démarré, actualisez ou revenez à cette page après 10 secondes',
    simulationStartError: 'Échec du démarrage de la simulation',
    runRequiresZoneSelection:
      'Sélectionnez au moins une zone avant de lancer la simulation.',
    solarNotIncludedInZones:
      "La production solaire est calculée au niveau du bâtiment et n'est pas incluse dans les résultats et comparaisons par zone.",
    resultsCalculatedAt: 'Calculé le {datetime}',
    resultsCalculatedWithStandard: 'Calculé le {datetime} selon {standard}',
    enovaMissingTiltakDescription:
      'Remplissez la description dans la section Mesures du Certificat énergétique.',
    enovaNoIncludedActions:
      "Activez au moins une mesure à inclure, ou décochez 'Inclure les mesures' et fournissez une description.",
    enovaMissingActionDescriptions:
      'Remplissez les descriptions pour : {actions}',
    enovaMissingCredentials:
      'Renseignez {fields} dans votre profil utilisateur avant d’envoyer à Enova.',
    enovaNoMatrikkelSelected:
      'Sélectionnez au moins une bruksenhet dans la section Matrikkeldata avant d’envoyer à Enova.',
    enovaZonesNotSimulated:
      'Exécutez la simulation de l’étiquette énergétique pour les zones sélectionnées avant d’envoyer à Enova.',
    enovaNonResidentialMultipleUnits:
      'Une seule unité peut être sélectionnée pour les sections non résidentielles.',
    confirmSendToEnovaMessage: 'Êtes-vous sûr de vouloir envoyer à Enova ?',
    enovaSendWithMessagesWarning:
      'La simulation contient {count} messages. Vérifiez-les avant d’envoyer à Enova.',
    simulationProgress: 'Simulation énergétique du bâtiment en cours...',
    simulationMessages: 'Messages de simulation',
    energyCalcWithStandard: 'Calculs énergétiques selon la norme {standard}.',
    energyCalc: 'Calculs énergétiques',
    noResults:
      'Aucun résultat de simulation disponible. Lancez une simulation pour voir les données énergétiques.',
    analyticsPlaceholder: "Les graphiques d'analyse seront affichés ici.",
    monthlyEnergyBudget: 'Budget énergétique mensuel (demande)',
    deliveredEnergyTitle: "Sources d'énergie livrée",
    deliveredEnergyDesc:
      "L'énergie totale livrée représente toutes les sources d'énergie fournies au bâtiment.",
    energyComparisonTitle: 'Comparaison énergétique (Net / Perte / Brut)',
    energyComparisonDesc:
      "Compare les besoins énergétiques nets, les pertes de distribution et l'énergie brute pour chaque catégorie. Brut = Net + Perte.",
    showTemperature: 'Afficher la ligne de température',
    energySourcesChartLabel: "Sources d'énergie",
    totalDeliveredEnergy: 'Énergie totale livrée',
    visible: 'Visible',
    noData: 'Pas de données',
    nettEnergy: 'Énergie nette',
    grossEnergy: 'Énergie brute',
    distributionLossLabel: "Perte de distribution et d'accumulation",
    noMonthlyData:
      'Les données mensuelles ne sont pas disponibles pour cette simulation.',
    monthlyChartHelp:
      'Chaque barre empilée représente la demande énergétique nette mensuelle ventilée par catégorie.',
    netEnergyDemand: "Besoin net d'énergie",
    distributionLosses: "Pertes de distribution et d'accumulation",
    grossEnergyDemand: "Besoin brut d'énergie",
    energySourcesTitle: "Sources d'\u00E9nergie (\u00C9nergie fournie)",
    deliveredExportedEnergyTitle: 'Énergie livrée et exportée',
    climaCorrectedEnergyTitle:
      '\u00C9nergie livr\u00E9e et export\u00E9e corrig\u00E9e climatiquement',
    netEnergyTitle: "Énergie nette (Besoin net d'énergie)",
    distributionLossTitle:
      "Pertes de distribution (Distribution et pertes d'accumulation)",
    grossEnergyTitle: "Énergie brute (Besoin brut d'énergie)",
    category: 'Catégorie',
    value: 'Valeur',
    unit: 'Unité',
    co2: 'CO₂ kg',
    energyType: "Type d'énergie",
    electricityCategory: '1. Électricité',
    fossilCategory: '2-3. Combustibles fossiles',
    renewableCategory: '4. Chauffage renouvelable',
    districtCategory: '5. Énergie de réseau',
    otherCategory: '6-8. Autres sources',
    totalCategory: 'Total',
    elSpecific: 'Él. postes spécifiques',
    elHeating: 'Él. pour chauffage des locaux',
    elCooling: 'Él. pour système de refroidissement',
    elDHW: 'Él. pour eau chaude sanitaire',
    elProducedUsed: 'Él. production pour usage propre',
    elProducedExported: 'Él. production exportée',
    oil: 'Pétrole',
    gas: 'Gaz',
    solidFuel: 'Combustible solide',
    solidBiofuel: 'Biocombustible solide',
    liquidBiofuel: 'Biocombustible liquide',
    gaseousBiofuel: 'Biocombustible gazeux',
    districtHeating: 'Chauffage urbain',
    districtCooling: 'Refroidissement urbain',
    other: 'Autre',
    sumDelivered: 'Total',
    spaceHeating: 'Chauffage des locaux',
    ventilationHeating: 'Chauffage de ventilation',
    hotWater: 'Eau chaude',
    spaceCooling: 'Refroidissement des locaux',
    ventilationCooling: 'Refroidissement de ventilation',
    fans: 'Ventilateurs',
    pumps: 'Pompes',
    lighting: 'Éclairage',
    technicalEquipment: 'Équipement technique',
    total: 'Total',
    // Heat loss
    heatLossTitle: 'Déperditions thermiques',
    heatLossDesc:
      'Répartition des déperditions thermiques par composant. Valeurs en kWh.',
    hlWalls: 'Murs',
    hlRoof: 'Toiture',
    hlFloor: 'Plancher sur le sol',
    hlWindows: 'Fenêtres',
    hlDoors: 'Portes',
    hlThermalBridge: 'Ponts thermiques',
    hlInfiltration: 'Infiltration',
    hlVentilation: 'Ventilation',
    hlTotal: 'Total',
    // Bilan des pertes de chaleur (tableau 3 NS 3031:2025)
    hlBudgetTitle: 'Bilan des pertes de chaleur',
    hlBudgetCategory: 'Poste de perte de chaleur',
    hlBudgetValue: 'Coefficient de perte de chaleur',
    hlWindowsDoors: 'Fenêtres et portes',
    hlTransmissionSum: 'Coefficient de perte, transmission, somme 1–5',
    hlClimateScreenSum: 'Coefficient de perte, enveloppe, somme 1–6',
    hlTotalSum: 'Coefficient de perte, total, somme 1–7',
    // Énergie primaire
    peDeliveredEnergy: 'Énergie livrée (électricité)',
    peDeliveredFuel: 'Combustible livré',
    peDistrictHeating: 'Chauffage urbain',
    peDistrictCooling: 'Refroidissement urbain',
    peOtherDelivered: 'Autre énergie livrée',
    peElExport: 'Production él. pour export',
    energyLabelTitle: 'Étiquette énergie',
    supplementaryEnergyTitle: 'Énergie supplémentaire',
    primaryEnergyFactorsTitle: 'Facteurs de pondération primaire',
    carCharging: 'Recharge véhicule',
    otherEnergyNeeded: 'Autre besoin énergétique',
    energyNeedForOtherBuildings: 'Besoin énergétique autres bâtiments',
    peFossilOil: 'Fioul fossile',
    peFossilGas: 'Gaz fossile',
    peFossilSolid: 'Combustible solide fossile',
    peBioOil: 'Biofioul',
    peBioGas: 'Biogaz',
    peBioSolid: 'Biocombustible solide',
    ventilationSpecsTitle: 'Spécifications ventilation et ventilateur',
    specificFanPower: 'Puissance spécifique ventilateur (SFP)',
    specificAirFlowIn: 'Débit spécifique soufflage en fonctionnement',
    specificAirFlowOut: 'Débit spécifique soufflage hors fonctionnement',
    specificExhaustAirFlowIn: 'Débit spécifique extraction en fonctionnement',
    specificExhaustAirFlowOut:
      'Débit spécifique extraction hors fonctionnement',
    hcsHeatingTitle: 'Systèmes de chauffage',
    hcsCoolingTitle: 'Systèmes de refroidissement',
    hcsType: 'Type',
    hcsHeatingFactor: 'Rendement facteur chaleur',
    hcsCoolingFactor: 'Rendement facteur froid',
    hcsEnergyCoverage: 'Taux de couverture énergétique',
    hcsInndata: 'Données d’entrée',
    hcsInstalledHeatingEffect:
      'Puissance spécifique installée pour chauffage des locaux et ventilation',
    hcsInstalledCoolingEffect:
      'Puissance spécifique installée pour refroidissement des locaux et ventilation',
    hcsSetpointInOperation:
      'Température de consigne équivalente en fonctionnement',
    hcsSetpointOutOfOperation:
      'Température de consigne équivalente hors fonctionnement',
    wpeTitle: 'Énergie livrée pondérée corrigée climatiquement',
    wpeColSource: 'Source d’énergie',
    wpeColDelivered: 'Énergie livrée et exportée corrigée climatiquement',
    wpeColFactor: 'Facteur de pondération',
    wpeColWeighted: 'Énergie livrée pondérée corrigée climatiquement',
    wpeTotal: 'Total, somme 1-6',
    wpeElectricity: 'Électricité livrée',
    wpeSolidBio: 'Biocombustible solide livré',
    wpeLiquidBio: 'Biocombustible liquide livré',
    wpeGasBio: 'Biocombustible gazeux livré',
    wpeSolidFossil: 'Combustible fossile solide livré',
    wpeLiquidFossil: 'Combustible fossile liquide livré',
    wpeGasFossil: 'Combustible fossile gazeux livré',
    wpeDistrictHeating: 'Chauffage urbain livré',
    wpeDistrictCooling: 'Refroidissement urbain livré',
    wpeOther: 'Autres vecteurs d’énergie livrés',
    wpeElExport: 'Production d’électricité exportée (déduction)',
    ekBasisHeader: 'Base pour l’étiquette énergétique',
    ekValueHeader: 'Valeur',
    ekSpecificWeighted:
      'Énergie livrée pondérée corrigée climatiquement spécifique',
    meTitle: 'Consommation énergétique mesurée (kWh/an)',
    meColSource: 'Vecteur d’énergie',
    meColYearGroup: 'Année',
    meColAverage: 'Moyenne',
    meTotalDelivered: 'Énergie livrée totale',
    meTotalNetDelivered: 'Énergie livrée nette totale (moins exportation)',
    icTitle: 'Température intérieure',
    icSubtitle: 'Moyenne mensuelle basée sur les valeurs horaires',
    icZoneLabel: 'Zone',
    icSingleZoneLabel: 'Température intérieure',
    dhcLocalHeatingElectricity: 'Chauffage local — électricité',
    dhcLocalHeatingFossilOil: 'Chauffage local — fioul fossile',
    dhcLocalHeatingFossilGas: 'Chauffage local — gaz fossile',
    dhcLocalHeatingFossilSolid: 'Chauffage local — combustible solide fossile',
    dhcLocalHeatingBioOil: 'Chauffage local — biofioul',
    dhcLocalHeatingBioGas: 'Chauffage local — biogaz',
    dhcLocalHeatingBioSolid: 'Chauffage local — biocombustible solide',
    dhcLocalDistrictHeating: 'Réseau de chaleur local',
    dhcLocalHeatPump: 'Pompe à chaleur locale',
    dhcLocalHeatingOther: 'Chauffage local — autres sources',
    dhcCentralHeatPump: 'Pompe à chaleur centrale',
    dhcCentralHeatingElectricity: 'Chauffage central — électricité',
    dhcCentralHeatingFossilOil: 'Chauffage central — fioul fossile',
    dhcCentralHeatingFossilGas: 'Chauffage central — gaz fossile',
    dhcCentralHeatingFossilSolid:
      'Chauffage central — combustible solide fossile',
    dhcCentralHeatingBioOil: 'Chauffage central — biofioul',
    dhcCentralHeatingBioGas: 'Chauffage central — biogaz',
    dhcCentralHeatingBioSolid: 'Chauffage central — biocombustible solide',
    dhcCentralDistrictHeating: 'Réseau de chaleur central',
    dhcCentralHeatingOther: 'Chauffage central — autres sources',
    dhcCentralSolarThermal: 'Solaire thermique central',
    dhcCentralCogeneration: 'Cogénération centrale',
    dhcLocalCooling: 'Refroidissement local',
    dhcCentralCoolingAirWater: 'Refroidissement central — air/eau',
    dhcCentralCoolingLiquidWater: 'Refroidissement central — eau/eau',
    dhcCentralFreeCooling: 'Refroidissement libre central',
    dhcCentralDistrictCooling: 'Réseau de froid central',
    // Charges internes
    internalLoadsTitle: 'Charges internes',
    internalLoadEnergyTitle: 'Charges internes - Besoin énergétique',
    internalLoadHeatTitle: 'Charges internes - Apports de chaleur',
    ilLighting: 'Éclairage',
    ilEquipment: 'Équipement technique',
    ilHotWater: 'Eau chaude',
    ilPeople: 'Personnes',
    internalLoadsChartTitle:
      'Charges internes (Besoin énergétique vs Apports de chaleur)',
    internalLoadsChartDesc:
      'Compare le besoin énergétique et les apports de chaleur des sources de charges internes.',
    ilEnergyNeed: 'Besoin énergétique',
    ilSpecificEnergyNeed: 'Besoin énergétique spécifique',
    ilSpecificHeatGain: 'Apport thermique spécifique',
    ilHeatGain: 'Apport de chaleur',
    // Month names
    month: 'Mois',
    monthJan: 'Jan',
    monthFeb: 'Fév',
    monthMar: 'Mars',
    monthApr: 'Avr',
    monthMay: 'Mai',
    monthJun: 'Juin',
    monthJul: 'Juil',
    monthAug: 'Août',
    monthSep: 'Sep',
    monthOct: 'Oct',
    monthNov: 'Nov',
    monthDec: 'Déc',
    // Information table (general + climate)
    bdTitle: 'Informations',
    bdParameter: 'Général',
    bdInputValue: "Valeur d'entrée",
    bdBuildingCategory: 'Catégorie de bâtiment',
    bdBuildingType: 'Type de bâtiment',
    bdYearOfConstruction: 'Année de construction',
    bdTekStandard: 'Norme TEK',
    bdCalculationDate: 'Date de calcul',
    bdClimateInformation: 'Climat',
    bdClimateStationSource: 'Source de la station climatique',
    bdClimateStation: 'Station climatique',
    bdClimateCorrectionFactor: 'Facteur de correction climatique',
    bdYearlyAverageTemperature: 'Température annuelle moyenne',
    efTitle: 'Flux énergétique',
    efColCategory: 'Poste énergétique',
    efColNet: 'Besoin énergétique net',
    efColDist: 'Pertes de distribution et de stockage',
    efColGross: 'Besoin énergétique brut',
    efColSpf: 'SPF',
    efColDelivered: 'Énergie livrée',
    efTotal: 'Total',
    // Facteurs de pondération vecteurs énergétiques (T.2 NS 3031:2025)
    wfTitle: 'Facteurs de pondération des vecteurs énergétiques',
    wfType: 'Type',
    wfWeightFactor: 'Facteur de pondération',
    wfClimateFactor: 'Facteur gaz à effet de serre (équivalent CO²)',
    wfEnergyPrice: "Prix de l'énergie",
    wfOtherWeighting: 'Autre pondération',
    wfElectricity: 'Électricité livrée',
    wfBioSolid: 'Biocombustible solide',
    wfBioLiquid: 'Biocombustible liquide',
    wfBioGas: 'Biocombustible gazeux',
    wfFossilSolid: 'Combustible fossile solide',
    wfFossilLiquid: 'Combustible fossile liquide',
    wfFossilGas: 'Combustible fossile gazeux',
    wfDistrictHeating: 'Chauffage urbain',
    wfDistrictCooling: 'Réseau de froid',
    wfOther: 'Autre',
    wfExportedElectricity: 'Électricité exportée',
    // Systèmes de distribution
    dsTitle: 'Systèmes de distribution',
    dsCategory: 'Paramètre',
    dsValue: "Valeur d'entrée",
    dsRoomHeating: 'Chauffage des locaux',
    dsVentilationHeating: 'Chauffage par ventilation',
    dsDhwCirculation: "Circulation d'eau chaude",
    dsRoomCooling: 'Refroidissement des locaux',
    dsVentilationCooling: 'Refroidissement par ventilation',
    dsPipeLength: 'Longueur de tuyau de distribution par surface chauffée',
    dsPumpPower: 'Puissance spécifique de pompe',
    // Électricité (tableau T.2 NS 3031:2025)
    elTitle: 'Électricité',
    elCategory: 'Paramètre',
    elValue: "Valeur d'entrée",
    elSolarEfficiency: 'Rendement annuel du système photovoltaïque',
    elSolarInstalled:
      "Puissance installée de l'installation photovoltaïque (Ppeak)",
    elSolarCoverage:
      'Couverture solaire du besoin énergétique spécifique électrique',
    elWindCoverage:
      'Couverture éolienne du besoin énergétique spécifique électrique',
    elChpEfficiency:
      'Rendement annuel moyen de la production électrique par cogénération',
    elChpCoverage:
      'Couverture par cogénération du besoin énergétique spécifique électrique',
  },

  energyLabelConfig: {
    airLeakageTitle: "Fuite d'air",
    airLeakageMeasured: "Fuite d'air mesurée",
    airLeakageMeasuredDate: 'Date de mesure',
    airLeakageGradeAHint:
      "La classe A nécessite une fuite d'air mesurée avec une date de mesure. Sans cela, l'étiquette est limitée à B.",
    actionsTitle: 'Actions',
    includeMeasures: "Inclure les mesures en cours d'évaluation",
    includeActivatedActions: 'Inclure les actions activées',
    loadingActions: 'Chargement des actions…',
    actionNameVentilation: 'Action ventilation',
    actionNameHeating: 'Action chauffage et climatisation',
    actionNameLighting: 'Action éclairage',
    actionNameSolar: 'Action panneaux solaires',
    actionNameControl: 'Action Contrôle & Régulation',
    actionsDescription:
      "Si aucune mesure n'est incluse, décrivez plutôt la raison (par ex., construction neuve).",
    includedMeasuresInfo:
      "La liste des mesures incluses contient une évaluation des coûts et des conséquences concernant l'humidité et le climat intérieur pour chaque mesure énergétique. La liste peut servir de base à la planification d'un programme d'entretien et de mise à niveau du bâtiment.",
    description: 'Description',
    measuredValuesTitle: 'Valeurs mesurées',
    measuredValuesCheckbox: 'Valeurs mesurées',
    measuredValuesDescription:
      "Mesures de consommation d'énergie par type de source pour les 3 dernières années.",
    energySourcePlaceholder: "Source d'énergie (kWh)",
    addMeasurement: 'Ajouter une mesure',
    confirmDeleteMeasurement: 'Supprimer cette ligne de mesure ?',
    deliveredElectricity: 'Électricité livrée (kWh)',
    exportedElectricity: 'Électricité exportée (kWh)',
    fossilOil: 'Fioul fossile (kWh)',
    fossilGas: 'Gaz fossile (kWh)',
    fossilSolidFuel: 'Combustible solide fossile (kWh)',
    bioOil: 'Bio-huile (kWh)',
    bioGas: 'Biogaz (kWh)',
    bioSolidFuel: 'Biocombustible solide (kWh)',
    districtHeating: 'Chauffage urbain (kWh)',
    districtCooling: 'Refroidissement urbain (kWh)',
    other: 'Autre (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Données cadastrales',
    noUnitsFound: 'Aucune unité trouvée',
    street: 'Adresse',
    addressCode: 'Code adresse',
    postcode: 'Code postal',
    city: 'Ville',
    municipality: 'Commune',
    municipalityNumber: 'Numéro de la commune',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Numéro de bail',
    buildingNumber: 'Numéro du bâtiment',
    buildingType: 'Type de bâtiment',
    buildingStatus: 'Statut du bâtiment',
    industryType: "Type d'industrie",
    unitNumber: "Numéro d'unité",
    unitId: "ID de l'unité",
    unitType: "Type d'unité",
    sectionNumber: 'Numéro de section',
    sectionType: 'Type de section',
  },

  zoneSelection: {
    title: 'Zones à simuler',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    selected: '{count} sur {total} sélectionnés',
  },

  buildingTool: {
    showAll: 'Tout afficher',
    hideAll: 'Tout masquer',
    updateZone: 'Mettre à jour la zone',
    deleteZone: 'Supprimer la zone',
    title: 'Outil bâtiment',
    description:
      "Dessinez un polygone sur la carte pour tracer l'emprise du bâtiment, ajustez les paramètres et créez une zone avec des murs.",
    numberOfFloors: "Nombre d'étages",
    floorHeight: "Hauteur d'étage (m)",
    startFloor: 'Étage de départ',
    wallSegments: 'Segments de mur',
    totalPerimeter: 'Périmètre total',
    creating: 'Création...',
    createZoneAndWalls: 'Créer zone et murs',
    createSuccess: 'Zone et {count} mur(s) créés avec succès',
    createError: 'Échec de la création de la zone et des murs',
    joinBearings: 'Regrouper par orientation',
    splitBearings: 'Afficher tous les segments',
    joinButton: 'Joindre',
    splitButton: 'Séparer',
    floorArea: 'Surface au sol (m²)',
    roofArea: 'Surface de toiture (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Cliquez sur un bâtiment pour sélectionner son emprise',
    noBuildingFound: 'Aucun bâtiment trouvé',
    createAnother: 'Créer une autre zone',
    autoSelectTooltip: 'Sélection auto',
    drawPolygonTooltip: 'Dessiner polygone',
    drawStackedTooltip: 'Ajouter un étage au-dessus',
    drawStackedTooltipDisabled:
      'Ajouter un étage au-dessus (zone existante requise)',
    drawStackedHint: 'Cliquez sur une zone pour ajouter une copie au-dessus',
    snapToggleOn: 'Aimantation activée',
    snapToggleOff: 'Aimantation désactivée',
    splitTooltip: 'Diviser une zone',
    splitTooltipDisabled: 'Diviser une zone (zone requise)',
    splitTargetHint: 'Cliquez sur une zone à diviser',
    view3dTooltip: 'Vue 3D',
    splitPanelTitle: 'Diviser la zone',
    splitPanelDescription:
      'Faites glisser les curseurs pour positionner la coupe. La zone est divisée en deux moitiés.',
    splitPanelPickTargetHint:
      'Cliquez sur une zone de la carte pour choisir laquelle diviser.',
    splitPanelSplittingZone: 'Division : {name}',
    splitPanelCutPositionLabel: 'Position de coupe : {value}',
    splitPanelCutAngleLabel: 'Angle de coupe : {value}°',
    splitPanelCutLengthLabel: 'Longueur de coupe : {value}',
    splitPanelCutOffsetLabel: 'Décalage de coupe : {value}',
    splitPanelConfirm: 'Confirmer la division',
    splitPanelCommitting: 'Division en cours…',
    errorUpdateZone: 'Échec de la mise à jour de la zone',
    errorCreateStackedZone: "Échec de l'ajout d'un étage au-dessus de la zone",
    errorSplitZone: 'Échec de la division de la zone',
    errorDeleteZone: 'Échec de la suppression de la zone',
  },

  underDevelopment: 'Cette page est en cours de développement.',

  // excel export labels for the input data sheet
  excelExport: {
    headerSection: 'Section',
    headerName: 'Nom',
    headerParameter: 'Paramètre',
    headerValue: 'Valeur',
    headerUnit: 'Unité',
    inputDataSheetName: "Données d'entrée",
    boolYes: 'Oui',
    boolNo: 'Non',
    sectionThermalZones: 'Zones thermiques',
    sectionExteriorWalls: 'Murs extérieurs',
    sectionHvacUnits: 'Unités CVC',
    sectionHeatingCoolingModules: 'Modules chauffage/refroidissement',
    sectionCentralEnergyModules: 'Modules énergie centrale',
    sectionHeatPumps: 'Pompes à chaleur',
    sectionDistrictHeating: 'Chauffage urbain',
    sectionCombustionBoilers: 'Chaudières à combustion',
    sectionElectricBoilers: 'Chaudières électriques',
    sectionSolarThermal: 'Solaire thermique',
    sectionOtherEnergySources: "Autres sources d'énergie",
    sectionSolarPv: 'Solaire PV',
    sectionDomesticHotWater: 'Eau chaude sanitaire',
    sectionPipeConfigurations: 'Configurations de tuyauterie',
    sectionProductionEquipment: 'Équipement de production',
    sectionExcessEnergy: 'Énergie excédentaire',
    // excel-specific short labels
    area: 'Surface',
    uValue: 'Valeur U',
    yearInstalled: "Année d'installation",
    energySource: "Source d'énergie",
    systemEfficiency: 'Rendement du système',
    usedForHeating: 'Utilisé pour le chauffage',
    usedForCooling: 'Utilisé pour le refroidissement',
    usedForDHW: "Utilisé pour l'ECS",
    maxCapacity: 'Capacité max.',
    heatingCapacity: 'Capacité de chauffage',
    cop: 'COP',
    heatingEffect: 'Puissance de chauffage',
    coolingEffect: 'Puissance de refroidissement',
    co2eEmissionFactor: "Facteur d'émission CO\u2082e",
    energyPrice: "Prix de l'énergie",
    power: 'Puissance',
    // entity prefixes
    prefixWall: 'Mur',
    prefixWindow: 'Fenêtre',
    prefixDoor: 'Porte',
    prefixGate: 'Portail',
    prefixPipe: 'Tuyau',
    prefixHeatingBattery: 'Batterie de chauffage',
    prefixCoolingBattery: 'Batterie de refroidissement',
    prefixDxSystem: 'Système DX',
    prefixEnergySource: "Source d'énergie",
    prefixTank: 'Réservoir',
    prefixCopEntry: 'Entrée COP',
    // thermal zones
    heatedFloorArea: 'Surface chauffée (BRA)',
    numberOfFloors: "Nombre d'étages",
    floorHeight: "Hauteur d'étage",
    indoorTemperature: 'Température initiale',
    zoneClimate: 'Climat de zone',
    airLeakageGrade: 'Étanchéité - Grade',
    airLeakageN50: 'Étanchéité - n50',
    setpointHeating: 'Consigne - Chauffage',
    setpointCooling: 'Consigne - Refroidissement',
    thermalBridgeType: 'Pont thermique - Type',
    thermalBridgePsiValue: 'Pont thermique - valeur \u03C8',
    floorType: 'Plancher sur le sol - Type',
    floorArea: 'Plancher sur le sol - Surface',
    floorUValue: 'Plancher sur le sol - Valeur U',
    floorHeatLossCoeff: 'Plancher sur le sol - Coefficient de déperdition',
    roofType: 'Toiture - Type',
    roofArea: 'Toiture - Surface',
    roofUValue: 'Toiture - Valeur U',
    roofAngle: 'Toiture - Angle',
    roofWindowArea: 'Toiture - Surface vitrée',
    roofWindowUValue: 'Toiture - Fenêtre valeur U',
    roofWindowGValue: 'Toiture - Fenêtre valeur g',
    basementArea: 'Sous-sol - Surface de plancher',
    basementWallPerimeter: 'Sous-sol - Périmètre enterré',
    basementFillHeight: 'Sous-sol - Profondeur sous le terrain',
    basementWallThickness: 'Sous-sol - Épaisseur du mur',
    basementWallUValue: 'Sous-sol - Mur valeur U',
    basementFloorUValue: 'Sous-sol - Plancher valeur U',
    groundThermalConductivity: 'Sol - Conductivité thermique',
    groundHeatCapacity: 'Sol - Capacité thermique',
    groundPenetrationDepth: 'Sol - Profondeur de pénétration',
    thermalMassCategory: 'Masse thermique - Catégorie',
    thermalMassHeatCapacity: 'Masse thermique - Capacité thermique',
    thermalMassNormalized: 'Masse thermique - Capacité normalisée',
    // windows
    gValue: 'Valeur g',
    shadingFactor: "Facteur d'ombrage",
    externalBlinds: 'Stores extérieurs',
    externalBlindsGt: 'Stores extérieurs Gt',
    externalScreen: 'Screen extérieur',
    externalScreenGt: 'Screen extérieur Gt',
    internalShading: 'Protection solaire intérieure',
    internalShadingGt: 'Protection solaire intérieure Gt',
    // hvac
    heatRecoveryType: 'Type de récupération de chaleur',
    motorType: 'Type de moteur',
    flowType: 'Type de débit',
    sfpSupply: 'SFP (soufflage)',
    sfpExtract: 'SFP (extraction)',
    sfpNonOperating: 'SFP hors fonctionnement',
    coverageArea: 'Surface desservie',
    coverageVolume: 'Volume desservi',
    fanPowerSupply: 'Puissance ventilateur (soufflage)',
    fanPowerExtract: 'Puissance ventilateur (extraction)',
    heatRecoveryEfficiency: 'Rendement récupération de chaleur',
    frostProtection: 'Protection antigel',
    frostProtectionTemperature: 'Température de protection antigel',
    airVolumeOperatingSupply: "Volume d'air fonctionnement (soufflage)",
    airVolumeCapacitySupply: "Volume d'air capacité (soufflage)",
    airVolumeNonOperatingSupply: "Volume d'air hors fonctionnement (soufflage)",
    airVolumeOperatingExtract: "Volume d'air fonctionnement (extraction)",
    airVolumeCapacityExtract: "Volume d'air capacité (extraction)",
    airVolumeNonOperatingExtract:
      "Volume d'air hors fonctionnement (extraction)",
    supplyTemperature: 'Température de soufflage',
    onlyNaturalPassiveVentilation: 'Ventilation naturelle/passive uniquement',
    batteryEer: 'EER',
    systemType: 'Type de système',
    coolingOnly: 'Refroidissement uniquement',
    ambientTemperature: 'Température ambiante',
    tankPurpose: 'Usage',
    tankVolume: 'Volume',
    tankInsulationGrade: "Grade d'isolation",
    tankHeatLossCoeff: 'Coefficient de déperdition',
    tankSetpointTemp: 'Température de consigne',
    tankMaxTemp: 'Température max.',
    tankMinTemp: 'Température min.',
    heatPumpType: 'Type de pompe à chaleur',
    nominalLoad: 'Charge nominale',
    minimumLoad: 'Charge minimale',
    degradationCoefficient: 'Coefficient de dégradation',
    liquidSource: 'Source liquide',
    sourceTemperature: 'Température source',
    sourceYearlyAvgTemp: 'Température moyenne annuelle source',
    sourceTempAmplitude: 'Amplitude de température source',
    copSourceTemp: 'Temp. source',
    copMaxEffectLow: 'Effet max. (basse temp.)',
    copMaxEffectHigh: 'Effet max. (haute temp.)',
    copFullLoadLow: 'COP pleine charge (basse temp.)',
    copFullLoadHigh: 'COP pleine charge (haute temp.)',
    copNormalLoadLow: 'COP charge normale (basse temp.)',
    copNormalLoadHigh: 'COP charge normale (haute temp.)',
    copLowLoadLow: 'COP charge partielle (basse temp.)',
    copLowLoadHigh: 'COP charge partielle (haute temp.)',
    boilerType: 'Type de chaudière',
    efficiencyAtLowerLoad: 'Rendement à charge partielle',
    effectAtFullLoad: 'Effet à pleine charge',
    isCondensing: 'Chaudière à condensation',
    seasonalMeanTemperature: 'Température moyenne saisonnière',
    fuelSource: 'Source de combustible',
    fuelEnergyContent: 'Contenu énergétique combustible',
    fuelCo2EmissionFactor: 'Combustible facteur CO\u2082',
    operatingStart: 'Début de fonctionnement',
    operatingEnd: 'Fin de fonctionnement',
    phi: 'Phi',
    insulationGrade: "Grade d'isolation",
    tilt: 'Inclinaison',
    collectorArea: 'Surface de capteur',
    pipeLength: 'Longueur de tuyau',
    pipeUValue: 'Tuyau valeur U',
    efficiencyAtNormalConditions: 'Rendement en conditions normales',
    heatLossLinearCoefficient: 'Coefficient linéaire de déperdition',
    heatLossCoefficient: 'Coefficient de déperdition',
    fuelType: 'Type de combustible',
    panelArea: 'Surface de panneau',
    nominalEfficiency: 'Rendement nominal',
    panelAngle: 'Angle du panneau',
    panelAzimuth: 'Azimut du panneau',
    inverterEfficiency: 'Rendement onduleur',
    degradationLoss: 'Perte de dégradation',
    inverterLoss: 'Perte onduleur',
    transmissionProduct: 'Produit de transmission (0-1)',
    temperatureCoefficient: 'Coefficient de température (%/°C)',
    incidentAngleModifier: "Modificateur d'angle d'incidence (0-1)",
    heatLossFactor: 'Facteur de déperdition',
    pvMountingType: 'Type de montage',
    windExposure: 'Exposition au vent',
    pvCellType: 'Type de cellule',
    heaterType: 'Type de chauffe-eau',
    useNormedData: 'Données normalisées',
    placementType: 'Type de placement',
    volume: 'Volume',
    setpointTemperature: 'Température de consigne',
    heatingElementPower: 'Puissance résistance',
    specificHeatLoss: 'Déperdition spécifique',
    maxPowerDemand: 'Puissance max. demandée',
    usagePattern: "Profil d'utilisation",
    heatContributionPercent: 'Contribution thermique pourcentage',
    distributionSystemType: 'Type de système de distribution',
    pipeSpecificLength: 'Longueur spécifique tuyau',
    tapCyclesPerDay: 'Cycles de puisage par jour',
    pipesInHeatedRoom: 'Tuyaux en local chauffé',
    specificPumpPower: 'Puissance spécifique pompe',
    pipeLinearUValue: 'Tuyau valeur U linéaire',
    avgTempOutsideHeatedRoom: 'Temp. moy. hors local chauffé',
    greyWaterRecovery: 'Récupération eaux grises',
    greyWaterEfficiency: 'Rendement eaux grises',
    greyWaterShare: 'Part eaux grises',
    greyWaterConnectionLossFactor: 'Eaux grises facteur perte raccordement',
    greyWaterPatternLossFactor: 'Eaux grises facteur perte profil',
    waterSystemQuality: "Qualité du système d'eau",
    pipeInsulationType: "Type d'isolation tuyau",
    spp: 'SPP',
    constantFlow: 'Débit constant',
    lengthOfPipe: 'Longueur de tuyau',
    percentageInHeatedSpace: 'Pourcentage en espace chauffé',
    avgTempOutsideHeatedSpace: 'Temp. moy. hors espace chauffé',
    temperatureReturn: 'Température retour',
    temperatureSupply: 'Température départ',
    eligibleForHarvesting: 'Éligible à la récupération',
    medium: 'Fluide',
    temperature: 'Température',
    amount: 'Quantité',
    ductShape: 'Forme de conduit',
    diameter: 'Diamètre',
    width: 'Largeur',
    height: 'Hauteur',
    airSpeed: "Vitesse de l'air",
  },

  actions: {
    ventilation: {
      pageTitle: 'Ventilation',
      ventilationUnits: 'Unités de ventilation',
      noHvacUnits:
        "Aucune unité CVC trouvée. Ajoutez des unités CVC dans la section Systèmes CVC d'abord.",
      usingUnits:
        "Utilisation de {count} unité(s) de ventilation activée(s) de l'inspection du bâtiment.",
      enableUnitsHint:
        "Activez les unités de ventilation ci-dessous pour les inclure dans l'action.",
    },
    lighting: {
      pageTitle: 'Éclairage',
      thermalZones: 'Zones thermiques',
      noZones:
        "Aucune zone thermique trouvée. Ajoutez des zones thermiques dans la section Zones thermiques d'abord.",
      usingZones:
        "Utilisation de {count} zone(s) thermique(s) activée(s) pour l'action d'éclairage.",
      enableZonesHint:
        "Activez les zones thermiques ci-dessous pour les inclure dans l'action d'éclairage.",
      unit: 'W/m\u00B2',
      presenceControl: 'Détection de présence (éclairage)',
      presenceControlLabel: 'Détection de présence :',
      presenceYes: 'Oui (facteur : {value})',
      presenceNo: 'Non',
    },
    heating: {
      pageTitle: 'Chauffage & refroidissement',
      thermalZones: 'Zones thermiques',
      usingZones:
        "Utilisation de {count} zone(s) thermique(s) activée(s) pour l'action de chauffage.",
      enableZonesHint:
        "Activez les zones thermiques ci-dessous pour les inclure dans l'action de chauffage.",
      addNewSystem: 'Ajouter un nouveau système',
      addSystemDialogTitle: 'Ajouter un nouveau système',
      template: 'Modèle',
      systemName: 'Nom du système',
      priorityHelp: '1 = priorité la plus élevée',
      unnamed: 'Sans nom',
      chipNew: 'NOUVEAU',
      chipRemoved: 'SUPPRIMÉ',
      chipModified: 'MODIFIÉ',
      remove: 'Retirer',
      delete: 'Supprimer',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce système ?',
      undo: 'Annuler',
      noExistingSystems:
        'Aucun système de chauffage/refroidissement existant dans cette zone.',
      enableZoneHint:
        'Activez cette zone pour configurer les systèmes de chauffage/refroidissement.',
      existingSystems: '{count} système(s) existant(s)',
      templateAirWaterHP: 'Pompe à chaleur air/eau',
      templateAirAirHP: 'Pompe à chaleur air/air',
      templateAirToAirHP: 'Pompe à chaleur air/air',
      templateGroundSourceHP: 'Pompe à chaleur géothermique',
      templateElectricBoiler: 'Chaudière électrique',
      templateDistrictHeating: 'Chauffage urbain',
      templateDistrictCooling: 'Refroidissement urbain',
    },
    solar: {
      pageTitle: 'Photovoltaïque',
      solarPvModules: 'Modules photovoltaïques',
      noModules:
        'Aucun module photovoltaïque trouvé. Ajoutez des modules dans la section Photovoltaïque.',
      usingModules:
        "Utilisation de {count} module(s) photovoltaïque(s) activé(s) depuis l'inspection.",
      enableModulesHint:
        "Activez les modules photovoltaïques ci-dessous pour les inclure dans l'action.",
      addNewModule: 'Ajouter un nouveau module',
      chipNew: 'Nouveau',
      noExistingModules: 'Aucun module photovoltaïque existant.',
    },
    control: {
      pageTitle: 'Contrôle & Régulation',
      energyReductionPercent: 'Réduction énergétique [%]',
      energyReductionHint:
        "Pourcentage de réduction de l'énergie totale livrée par rapport à la simulation de référence.",
    },
    overview: {
      overviewTitle: "Vue d'ensemble des actions",
      combinedResults: 'Résultats de simulation combinés',
      notSimulated: 'Pas encore simulé',
      noActiveActions:
        "Aucune action active. Activez des actions sur les pages d'action individuelles.",
      activeActions: 'Actions actives',
      runCombinedSimulation: 'Lancer la simulation du bâtiment',
      noUnitsSelected: 'Aucune unité sélectionnée',
      noZonesSelected: 'Aucune zone thermique sélectionnée',
      noModulesSelected: 'Aucun module sélectionné',
      totalInvestment: 'Investissement total',
      priorityUpdateFailed: 'Échec de la mise à jour de la priorité',
    },
  },

  scenarioSync: {
    outOfSync:
      "L'inspection a changé depuis la dernière synchronisation de ce scénario.",
    legacyOutOfSync:
      "L'inspection a changé depuis la création de ce scénario. Ce scénario est antérieur à la prise en charge de la synchronisation, créez donc un nouveau scénario pour inclure les dernières modifications.",
    reviewChanges: 'Examiner les modifications',
    notSet: 'Non défini',
    items: 'éléments',
    dialogTitle: "Mettre à jour le scénario depuis l'inspection",
    dialogIntro:
      "Les modifications de l'inspection sont appliquées automatiquement et vos propres modifications du scénario sont conservées. Lorsque les deux côtés ont modifié le même champ, choisissez la valeur à conserver.",
    conflictsHeading: 'conflits nécessitent votre décision',
    noConflicts: '0 conflit',
    added: 'Nouveau',
    removed: 'Supprimé',
    removedInScenario:
      'Supprimé dans ce scénario, la suppression est conservée',
    removeConflict: "Supprimé dans l'inspection, mais modifié dans ce scénario",
    keepEntity: 'Conserver',
    removeEntity: 'Supprimer',
    keepScenario: 'Conserver la valeur du scénario',
    takeParent: "Utiliser la valeur de l'inspection",
    keptOverrides:
      'champs conservent vos modifications du scénario (la mise à jour ne les écrase pas)',
    noChanges: 'Aucune différence à synchroniser.',
    markSynced: 'Marquer comme synchronisé',
    applySync: 'Mettre à jour le scénario',
    syncSuccess: "Scénario mis à jour depuis l'inspection",
    syncError: 'Échec de la synchronisation du scénario',
    resimulateHint:
      'Relancez ensuite la simulation pour actualiser les résultats.',
    collections: {
      inspection: 'Inspection',
      thermalZones: 'Zones',
      exteriorWalls: 'Murs extérieurs',
      windowAreas: 'Fenêtres',
      doorAreas: 'Portes',
      gateAreas: 'Portails',
      operationalLoads: 'Charges internes',
      thermalZoneLinks: 'Liaisons de zones',
      hvacUnits: 'Systèmes de ventilation',
      heatingCoolingModules: 'Chauffage et refroidissement',
      centralEnergyModules: 'Énergie centrale',
      combustionBoilers: 'Chaudières à combustion',
      districtHeatings: 'Chauffage urbain',
      electricBoilers: 'Chaudières électriques',
      otherSources: "Autres sources d'énergie",
      solarTermals: 'Solaire thermique',
      heatPumps: 'Pompes à chaleur',
      productionEquipments: 'Équipements de production',
      solarPvModules: 'Photovoltaïque',
      excessEnergyModules: "Excédent d'énergie",
      domesticHotWaters: 'Eau chaude sanitaire',
      actionModules: 'Mesures',
      pipeLinks: 'Liaisons de tuyauterie',
      batteries: 'Batteries',
    },
  },

  scenario: {
    intro:
      "Créez une ou plusieurs copies modifiables de cette inspection. Modifiez ce que vous voulez dans une copie, puis lancez la simulation pour la comparer à l'original.",
    introExisting:
      "Un scénario de cette inspection existe déjà. Ouvrez-le pour continuer à le modifier, ou repartez de zéro depuis l'état actuel de l'original.",
    bannerNotice:
      "Scénario. Les modifications ici n'affectent pas l'inspection d'origine.",
    createScenario: 'Créer un scénario',
    addScenario: 'Ajouter un scénario',
    scenarioName: 'Nom du scénario',
    scenarioNamePlaceholder: 'p. ex. Nouveau système de ventilation',
    unnamedScenario: 'Scénario sans nom',
    creating: 'Création…',
    createNewScenario: 'Créer un nouveau scénario',
    renameScenario: 'Modifier le nom et la priorité de l’action',
    deleteScenario: 'Supprimer le scénario',
    confirmDeleteScenario: 'Supprimer ce scénario ?',
    working: 'Traitement…',
    backToOriginal: "Retour à l'original",
    confirmReplace:
      "Remplacer le scénario existant par une nouvelle copie de l'original ? Le scénario actuel sera supprimé.",
    createFailed: 'Échec de la création du scénario',
    replaceFailed: 'Échec du remplacement du scénario',
    renameFailed: 'Échec du renommage du scénario',
    deleteFailed: 'Échec de la suppression du scénario',
    existingCreated: 'Créé le {date}',
    existingCreatedBy: 'Créé le {date} par {name}',
    generalNotes: 'Notes générales',
    generalNotesPlaceholder:
      'Expliquez l’action aussi en détail que possible : ce qui a changé concrètement et pourquoi.',
    notesRequired: 'Les notes générales sont obligatoires',
    investmentCost: 'Coût d’investissement [NOK]',
    runToCompare: 'Lancez la simulation du scénario pour comparer',
    savingsUnavailable:
      'Les économies n’ont pas encore pu être calculées. Les données de prix sont manquantes ou incomplètes.',
    compareLeftLabel: 'Original',
    compareRightLabel: 'Scénario',
    compareAgainst: 'Comparer à',
    noComparison: 'Aucune comparaison',
    actionTypeLabel: "Type d'action",
    selectActionType: "Sélectionner le type d'action",
    actionTypes: {
      buildingShell: 'Enveloppe du bâtiment',
    },
  },

  report: {
    dragDropHint:
      'Réorganisez les chapitres et les champs dans le menu latéral.',
    generateReport: 'Générer le rapport',
    reportLanguage: 'Langue du rapport',
    addChapter: 'Ajouter un chapitre',
    exportToWord: 'Exporter vers Word',
    exportingToWord: 'Exportation vers Word...',
    exportingProgress:
      'Exportation vers Word — {current} sur {total} : {label}',
    sources: 'Sources',
    noChapters:
      'Aucun chapitre pour le moment. Ajoutez un chapitre pour commencer.',
    editTitle: 'Modifier le titre',
    removeChapter: 'Supprimer le chapitre',
    noFields:
      'Aucun champ de texte pour le moment. Ajoutez un champ pour commencer.',
    fieldTitlePlaceholder: 'Titre du nouveau champ...',
    addField: 'Ajouter un champ',
    confirmRemoveChapter: 'Supprimer le chapitre « {title} » ?',
    generateWithAI: "Générer avec l'IA",
    hideAuditLog: "Masquer le journal d'audit",
    showAuditLog: "Afficher le journal d'audit",
    removeField: 'Supprimer le champ',
    promptLabel: 'Prompt (utilisé pour la génération IA)',
    promptPlaceholder: 'Écrivez les instructions pour la génération IA...',
    generateText: 'Générer le texte',
    textPlaceholder: 'Écrivez le contenu ici, ou utilisez la génération IA',
    confirmRemoveField: 'Supprimer le champ « {title} » ?',
    addChapterTitle: 'Ajouter un nouveau chapitre',
    chapterTitleLabel: 'Titre du chapitre',
    chapterTitlePlaceholder: 'Ex. Climat intérieur et confort',
    fetchError: 'Impossible de récupérer le rapport',
    saveError: 'Impossible de sauvegarder le rapport',
    generateError: 'Impossible de générer le texte',
    generatingStatus:
      "Le rapport est en cours de génération par l'IA. Cela peut prendre plusieurs minutes — la page se mettra à jour automatiquement.",
    generateSuccess: 'Rapport généré avec succès',
    generateTimeout:
      'La génération du rapport a expiré. Le service peut encore être en cours de traitement — essayez de rafraîchir la page plus tard.',
    noContent:
      'Pas encore de contenu. Générez le rapport ou ajoutez du texte pour voir un aperçu.',
    generationPromptLog: 'Généré avec le prompt :',
  },
};

export default BUILDING_INSPECTION;
